import * as usertypes from '../constants/actionsUserTypes';
import * as vastypes from '../constants/vasActionTypes';
import * as transtypes from '../constants/transActionTypes';
import * as ctrltwrtypes from '../constants/ctrlTwrActionTypes';
import * as labelgentypes from '../constants/labelGenActionTypes';
import * as inventorytypes from '../constants/inventoryActionTypes'
import * as visibilitytypes from '../constants/visibilityActionTypes'
import axios from 'axios';
import async from 'async';
import { appAPI } from '../../app/appConfig';
import { awsCognitoConfig } from '../../app/awsCognitoConfig';
import { appSettings } from '../../app/appSettings'
import Logger from '../logger/Logger';
import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";
import React, { useState } from 'react';
import Auth from '@aws-amplify/auth';


const poolData = { UserPoolId: awsCognitoConfig.cognitoLogin.Auth.UserPoolId, ClientId: awsCognitoConfig.cognitoLogin.Auth.ClientId };
const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
const cognitoUser = userPool.getCurrentUser();


async function CheckAndRefreshToken() {
	try {
		const session = await Auth.currentSession();
		const accessToken = session.getAccessToken();
		const accessTokenExpiration = new Date(accessToken.getExpiration() * 1000); // Convert to milliseconds
		const currentTime = new Date();
		const jwtToken = session.getIdToken();


		if (accessTokenExpiration < currentTime) {
			// Token is expired, let's refresh it silently
			await Auth.currentAuthenticatedUser({ bypassCache: true }); // This silently refreshes the token

			const newSession = await Auth.currentSession();
			const newJwtToken = newSession.getIdToken();

			return newJwtToken.jwtToken
		} else {
			// Token is still valid
			// console.log('Access token is still valid.');
			return jwtToken.jwtToken
		}
	} catch (error) {
		// Handle any errors, e.g., user not authenticated or other issues
		// console.error('Error checking and refreshing token', error);
		return ''
	}

}


const noCognitoAuthCall = (_call) => {
	return (callback) => {

		axios({
			method: _call.type,
			url: `${_call.endpoint}`,
			crossDomain: true,
			headers: {
				// "Access-Control-Allow-Origin": "*",
				'x-api-key': appAPI.API.data.User_NewSignUp_API_Key
			},
			// data: {"param": _call.paramvalue}
			data: { "proc": _call.proc, "param": _call.paramvalue }
		})
			.then((res) => {
				Logger.log({
					id: Logger.LOGGER_IDS.SERVICES,
					type: Logger.types.LOG
				}, 'CALL COMPLETE: ', _call.onComplete, res, _call.saveData);

				_call.next({
					type: _call.onComplete,
					payload: res.data,
					data: _call.data || null,
					saveData: _call.saveData || null
				});

				callback(null, _call.onComplete, _call.data);
			})
			.catch((error) => {

				Logger.log({
					id: Logger.LOGGER_IDS.SERVICES,
					type: Logger.types.LOG
				}, 'CALL ERROR: ', _call.onError, error, _call.saveData);

				_call.next({
					type: _call.onError,
					payload: error,
					data: _call.data || null,
					saveData: _call.saveData || null
				});

				callback(null, _call.onError);

				// sessionStorage.clear();
				// window.location.reload();
				// window.alert('Session expired, please log in again.')

			});


	};
};

const checkForDownloadFromS3 = (_res) => {
	var statusCode = 200
	try {
		statusCode = _res['data']['statusCode']
	}
	catch (e) {
	}

	if (statusCode == 600) {
		window.alert('Downloading results. Please allow popups for this site.')
		var newData = JSON.parse(_res.data.body);
		try {
			// Auto-download the file
			const link = document.createElement('a');
			link.href = newData.URL;
			// link.download = newData.MSG;
			link.click();


			// window.open(newData.URL)
		}
		catch (e) {
			window.alert('Error downloading file.')
		}
	}
	else if (statusCode == 400) {
		try {
			if ((typeof (_res.data.body) !== 'undefined')) {
				var errorMsgJSON = JSON.parse(_res.data.body)
				if ((typeof (errorMsgJSON['MSG']) !== 'undefined')) {
					var errorMsg = errorMsgJSON['MSG']
					window.alert(errorMsg)
				}
			}
		}
		catch (e) {
			window.alert('Error')
		}
	}
}

const getCall = (_call) => {
	var _user = ''
	try {
		_user = _call['user']
	}
	catch (e) {
		_user = ''
	}
	return (callback) => {
		var jwtToken = ''

		if (_call.onComplete === 'USER_SIGNUP_COMPLETE') {
			jwtToken = ''
		}
		else {
			// var yourIdToken
			if (cognitoUser === null) { window.location.reload(); }

			CheckAndRefreshToken()
				.then((jwtToken) => {

					axios({
						method: _call.type,
						url: `${_call.endpoint}`,
						crossDomain: true,
						headers: {
							// "Access-Control-Allow-Origin": "*",
							'Authorization': jwtToken
						},
						// data: {"param": _call.paramvalue}
						data: { "proc": _call.proc, "param": _call.paramvalue, "user": _user }
					})
						.then((res) => {
							checkForDownloadFromS3(res)
							Logger.log({
								id: Logger.LOGGER_IDS.SERVICES,
								type: Logger.types.LOG
							}, 'CALL COMPLETE: ', _call.onComplete, res, _call.saveData);

							_call.next({
								type: _call.onComplete,
								payload: res.data,
								data: _call.data || null,
								saveData: _call.saveData || null
							});

							callback(null, _call.onComplete, _call.data);
						})
						.catch((error) => {

							Logger.log({
								id: Logger.LOGGER_IDS.SERVICES,
								type: Logger.types.LOG
							}, 'CALL ERROR: ', _call.onError, error, _call.saveData);

							_call.next({
								type: _call.onError,
								payload: error,
								data: _call.data || null,
								saveData: _call.saveData || null
							});

							callback(null, _call.onError);


						});

				})

		}
	};
};


const getDataNoCognitoAuth = (_calls) => {
	if (!_calls || !_calls.data) {
		return null;
	}

	const calls = [];

	_calls.data.forEach((call) => {
		calls.push(noCognitoAuthCall(call));
	});

	let callType = _calls.type || 'series';
	async[callType](calls, null);
};

const getData = (_calls) => {
	if (!_calls || !_calls.data) {
		return null;
	}

	const calls = [];

	_calls.data.forEach((call) => {
		calls.push(getCall(call));
	});

	let callType = _calls.type || 'series';
	async[callType](calls, null);
};


const getAPIData = (_calls) => {
	if (!_calls || !_calls.data) {
		return null;
	}

	const calls = [];

	_calls.data.forEach((call) => {
		calls.push(getAPICall(call));
	});

	let callType = _calls.type || 'series';
	async[callType](calls, null);
};


const getAPICall = (_call) => {
	return (callback) => {
		var jwtToken = ''

		if (_call.onComplete === 'USER_ADD_COMPLETE') {
			jwtToken = ''
		}
		else {
			var yourIdToken
			if (cognitoUser === null) { window.location.reload(); }
			cognitoUser.getSession(function (err, data) {
				if (err) {
					// Prompt the user to reauthenticate by hand...
					//   window.alert("Session expired, please reload page.")
					console.log('Session expired, auto reload page')
					window.location.reload();
				} else {

					const cognitoUserSession = data;
					yourIdToken = cognitoUserSession.getIdToken().jwtToken;
					//   const yourAccessToken = cognitoUserSession.getAccessToken().jwtToken;
				}
			});
			jwtToken = yourIdToken
		}

		axios({
			method: _call.type,
			url: `${_call.endpoint}`,
			crossDomain: true,
			headers: {
				"Access-Control-Allow-Origin": "*",
				'authorizationToken': _call.authToken,
				'Authorization': jwtToken
			},
			data: _call.paramvalue
			// data: _call.paramvalue


			// method: _call.type,
			// url: `${_call.endpoint}`,
			// // crossDomain : true,
			// // mode: 'no-cors',
			// headers: {
			// 	"Access-Control-Allow-Origin": "*",
			// 	// 'Authorization' : jwtToken
			// 	// 'Content-Type': 'text/plain',
			// 	'authorizationToken' : _call.authToken
			// 	},
			// // data: {"param": _call.paramvalue}
			// // data: {"param": _call.paramvalue }
			// data: _call.paramvalue
		})
			.then((res) => {
				Logger.log({
					id: Logger.LOGGER_IDS.SERVICES,
					type: Logger.types.LOG
				}, 'CALL COMPLETE: ', _call.onComplete, res, _call.saveData);

				_call.next({
					type: _call.onComplete,
					payload: res.data,
					data: _call.data || null,
					saveData: _call.saveData || null
				});

				callback(null, _call.onComplete, _call.data);
			})
			.catch((error) => {
				Logger.log({
					id: Logger.LOGGER_IDS.SERVICES,
					type: Logger.types.LOG
				}, 'CALL ERROR: ', _call.onError, error, _call.saveData);

				axios({
					method: _call.type,
					url: `${_call.endpoint}`,
					crossDomain: true,
					headers: {
						"Access-Control-Allow-Origin": "*",
						'authorizationToken': _call.authToken,
						'Authorization': jwtToken
					},
					data: _call.paramvalue
					// data: _call.paramvalue
				})
					.then((res) => {
						Logger.log({
							id: Logger.LOGGER_IDS.SERVICES,
							type: Logger.types.LOG
						}, 'CALL COMPLETE: ', _call.onComplete, res, _call.saveData);

						_call.next({
							type: _call.onComplete,
							payload: res.data,
							data: _call.data || null,
							saveData: _call.saveData || null
						});

						callback(null, _call.onComplete, _call.data);
					})
					.catch((error) => {
						Logger.log({
							id: Logger.LOGGER_IDS.SERVICES,
							type: Logger.types.LOG
						}, 'CALL ERROR: ', _call.onError, error, _call.saveData);

						_call.next({
							type: _call.onError,
							payload: error,
							data: _call.data || null,
							saveData: _call.saveData || null
						});

						callback(null, _call.onError);
					});
			});
	};
};

const dataService = store => next => action => {



	next(action);

	switch (action.type) {





		////////////////////////////////////////////////////////////COMMON SERVICES///////////////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




		case ctrltwrtypes.DOWNLOAD_FILE_FROM_S3_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.FileDownloadAPI, ////***************This is specific to file download****************
							next,
							// onError: ctrltwrtypes.ON_ERROR,
							onError: ctrltwrtypes.DOWNLOAD_FILE_FROM_S3_ERROR,
							onComplete: ctrltwrtypes.DOWNLOAD_FILE_FROM_S3_COMPLETE,
							proc: action.payload.S3Bucket,
							paramvalue: action.payload.ObjectName + "," + action.payload.FilenameToSave
						}
					]
				}
			)
			break;







		////////////////////////////////////////////////////////////USER SERVICES///////////////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

		// This is a public API since user doesn't have account yet
		case usertypes.USER_SIGNUP_POST:
			getDataNoCognitoAuth(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WMS_User_NewSignUp,  // This is a public API since user doesn't have account yet
							next,
							onError: usertypes.USER_SIGNUP_ERROR,
							onComplete: usertypes.USER_SIGNUP_COMPLETE,
							proc: 'WebApp_User_NewSignUp',  //Need to type WebApp
							paramvalue: "'" + action.payload.email + "', '" + action.payload.firstname + "', '" + action.payload.lastname + "', " + action.payload.customer + "," + action.payload.warehouse
						}
					]
				}
			)
			break;




		// All other user APIs:
		case usertypes.APP_SIGNIN:
			getData(
				{
					type: 'series',
					data: [

						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.APP_SIGNIN_ERROR,
							onComplete: usertypes.APP_SIGNIN_COMPLETE,
							proc: 'User_App_Signin', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'"
						}
					]
				}
			)
			break;


		case usertypes.GET_ALL_USERS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.GET_ALL_USERS_ERROR,
							onComplete: usertypes.GET_ALL_USERS_COMPLETE,
							proc: 'User_GetAllUsers', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userEmailToSearch + "," + action.payload.userIdToSearch + "," + action.payload.ModuleID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case usertypes.POST_APPROVE_USER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.POST_APPROVE_USER_ERROR,
							onComplete: usertypes.POST_APPROVE_USER_COMPLETE,
							proc: 'User_PostApproveUser', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userIdToApprove + "," + action.payload.admin + "," + action.payload.accountApproved + "," + action.payload.newUserReadWrite + "," + action.payload.ModuleID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.userIdList
						}
					]
				}
			)
			break;

		case usertypes.POST_DELETE_USER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.POST_DELETE_USER_ERROR,
							onComplete: usertypes.POST_DELETE_USER_COMPLETE,
							proc: 'User_PostDeleteUser', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userIdToDelete
						}
					]
				}
			)
			break;

		case usertypes.POST_USER_ACCOUNT_EDIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.POST_USER_ACCOUNT_EDIT_ERROR,
							onComplete: usertypes.POST_USER_ACCOUNT_EDIT_COMPLETE,
							proc: 'User_PostAccountEdit', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userIdToEdit + "," + action.payload.firstName + "," + action.payload.lastName + "," + action.payload.active + "," + action.payload.admin + "," + action.payload.userIdList
						}
					]
				}
			)
			break;




		case usertypes.POST_USER_WAREHOUSES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.POST_USER_WAREHOUSES_ERROR,
							onComplete: usertypes.POST_USER_WAREHOUSES_COMPLETE,
							proc: 'User_WarehousesPost', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userIdToEdit + "," + action.payload.WarehouseID + "," + action.payload.admin + "," + action.payload.readwrite + "," + action.payload.deleteFromWarehouse
						}
					]
				}
			)
			break;


		case usertypes.POST_USER_MODULES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.POST_USER_MODULES_ERROR,
							onComplete: usertypes.POST_USER_MODULES_COMPLETE,
							proc: 'User_ModulesPost', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userIdToEdit + "," + action.payload.ModuleID + "," + action.payload.admin + "," + action.payload.readwrite + "," + action.payload.deleteFromModule
						}
					]
				}
			)
			break;


		case usertypes.USER_ADMIN_CUSTOMERS_ALL_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_ADMIN_CUSTOMERS_ALL_ERROR,
							onComplete: usertypes.USER_ADMIN_CUSTOMERS_ALL_COMPLETE,
							proc: 'User_Admin_CustomersAll_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;

		case usertypes.POST_USER_CUSTOMERS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.POST_USER_CUSTOMERS_ERROR,
							onComplete: usertypes.POST_USER_CUSTOMERS_COMPLETE,
							proc: 'User_CustomersPost', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userIdToEdit + "," + action.payload.CustomerID + "," + action.payload.admin + "," + action.payload.readwrite + "," + action.payload.deleteFromCustomer
						}
					]
				}
			)
			break;




		case usertypes.ACCOUNT_DETAILS_USER_WAREHOUSES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.ACCOUNT_DETAILS_USER_WAREHOUSES_ERROR,
							onComplete: usertypes.ACCOUNT_DETAILS_USER_WAREHOUSES_COMPLETE,
							proc: 'User_WarehousesGet', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;


		case usertypes.ACCOUNT_DETAILS_USER_CUSTOMERS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.ACCOUNT_DETAILS_USER_CUSTOMERS_ERROR,
							onComplete: usertypes.ACCOUNT_DETAILS_USER_CUSTOMERS_COMPLETE,
							proc: 'User_CustomersGet', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;



		case usertypes.ACCOUNT_DETAILS_USER_MODULES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.ACCOUNT_DETAILS_USER_MODULES_ERROR,
							onComplete: usertypes.ACCOUNT_DETAILS_USER_MODULES_COMPLETE,
							proc: 'User_ModulesGet', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;



		case usertypes.USER_WAREHOUSES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_WAREHOUSES_ERROR,
							onComplete: usertypes.USER_WAREHOUSES_COMPLETE,
							proc: 'User_WarehousesGet', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;

		case usertypes.USER_ORGANIZATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_ORGANIZATION_ERROR,
							onComplete: usertypes.USER_ORGANIZATION_COMPLETE,
							proc: 'User_Organization_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;


		case usertypes.USER_WAREHOUSE_LOCATIONS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_WAREHOUSE_LOCATIONS_ERROR,
							onComplete: usertypes.USER_WAREHOUSE_LOCATIONS_COMPLETE,
							proc: 'User_Warehouse_Location_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case usertypes.USER_CUSTOMERS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_CUSTOMERS_ERROR,
							onComplete: usertypes.USER_CUSTOMERS_COMPLETE,
							proc: 'User_CustomersGet', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;


		case usertypes.USER_LABELGEN_CARRIER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_LABELGEN_CARRIER_ERROR,
							onComplete: usertypes.USER_LABELGEN_CARRIER_COMPLETE,
							proc: 'User_LabelGen_Carrier_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;


		case usertypes.POST_USER_LABELGEN_CARRIER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.POST_USER_LABELGEN_CARRIER_ERROR,
							onComplete: usertypes.POST_USER_LABELGEN_CARRIER_COMPLETE,
							proc: 'User_LabelGen_Carrier_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.userIdToEdit + "," + action.payload.CarrierID + "," + action.payload.admin + "," + action.payload.readwrite + "," + action.payload.deleteFromCarrier
						}
					]
				}
			)
			break;


		case usertypes.USER_LABELGEN_CARRIER_SERVICE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_LABELGEN_CARRIER_SERVICE_ERROR,
							onComplete: usertypes.USER_LABELGEN_CARRIER_SERVICE_COMPLETE,
							proc: 'User_LabelGen_Carrier_Service_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;


		case usertypes.USER_MODULES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_MODULES_ERROR,
							onComplete: usertypes.USER_MODULES_COMPLETE,
							proc: 'User_ModulesGet', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.otherUsersID
						}
					]
				}
			)
			break;







		case usertypes.USER_COMPANY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_COMPANY_ERROR,
							onComplete: usertypes.USER_COMPANY_COMPLETE,
							proc: 'User_GetCompany', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'"
						}
					]
				}
			)
			break;

		case usertypes.USER_STORE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_STORE_ERROR,
							onComplete: usertypes.USER_STORE_COMPLETE,
							proc: 'User_GetStore', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'"
						}
					]
				}
			)
			break;

		case usertypes.USER_POSTATUS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_POSTATUS_ERROR,
							onComplete: usertypes.USER_POSTATUS_COMPLETE,
							proc: 'User_GetPOStatus', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'"
						}
					]
				}
			)
			break;

		case usertypes.GET_PAGE_CONFIG:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.ERROR_PAGE_CONFIG,
							onComplete: usertypes.COMPLETE_PAGE_CONFIG,
							proc: 'User_GetPageConfig', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "'," + action.payload.filter
						}
					]
				}
			)
			break;

		case usertypes.USER_ACCOUNT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_ACCOUNT_ERROR,
							onComplete: usertypes.USER_ACCOUNT_COMPLETE,
							proc: 'User_GetUserAccount', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;




		case usertypes.ADMIN_POST_NEW_SEAPORT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.ADMIN_POST_NEW_SEAPORT_ERROR,
							onComplete: usertypes.ADMIN_POST_NEW_SEAPORT_COMPLETE,
							proc: 'Admin_New_Seaport_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.SeaportCode + "," + action.payload.Port + "," + action.payload.Country + "," + action.payload.SeaportCodeID + "," + action.payload.delete
						}
					]
				}
			)
			break;


		case usertypes.ADMIN_POST_NEW_CUSTOMER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.ADMIN_POST_NEW_CUSTOMER_ERROR,
							onComplete: usertypes.ADMIN_POST_NEW_CUSTOMER_COMPLETE,
							proc: 'Admin_New_Customer_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerName + "," + action.payload.CustomerCode + "," + action.payload.CustomerID + "," + action.payload.delete
						}
					]
				}
			)
			break;


		case usertypes.USER_INVITE_NEW_USER_POST:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.USER_INVITE_NEW_USER_POST_ERROR,
							onComplete: usertypes.USER_INVITE_NEW_USER_POST_COMPLETE,
							proc: 'User_InviteNewUser-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.newUserEmail + "," + action.payload.FirstName + "," + action.payload.LastName + "," + action.payload.userList + "," + action.payload.siteAdmin + "," + action.payload.admin + "," + action.payload.newUserReadWrite + "," + action.payload.ModuleID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrganizationID
						}
					]
				}
			)
			break;





		///DELETE USER- SPECIFIC API

		case usertypes.USER_AWS_COGNITO_DELETE_USER_POST_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.AwsCognitoDeleteUserAPI,
							next,
							onError: usertypes.USER_AWS_COGNITO_DELETE_USER_POST_ERROR,
							onComplete: usertypes.USER_AWS_COGNITO_DELETE_USER_POST_COMPLETE,
							proc: '', //DON'T TYPE WebApp_
							paramvalue: action.payload.usernameToDelete
						}
					]
				}
			)
			break;



		///Invite USER- SPECIFIC API

		case usertypes.USER_AWS_COGNITO_INVITE_USER_POST_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.AwsCognitoInviteUserAPI,
							next,
							onError: usertypes.USER_AWS_COGNITO_INVITE_USER_POST_ERROR,
							onComplete: usertypes.USER_AWS_COGNITO_INVITE_USER_POST_COMPLETE,
							proc: '', //DON'T TYPE WebApp_
							paramvalue: action.payload.inviteEmail
						}
					]
				}
			)
			break;









		////COMMON ACTIONS


		case usertypes.COMMON_UNIT_OF_MEASURE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.COMMON_UNIT_OF_MEASURE_GET_ERROR,
							onComplete: usertypes.COMMON_UNIT_OF_MEASURE_GET_COMPLETE,
							proc: 'Common_Unit_Of_Measure-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;


		case usertypes.COMMON_UNIT_OF_WEIGHT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: usertypes.COMMON_UNIT_OF_WEIGHT_GET_ERROR,
							onComplete: usertypes.COMMON_UNIT_OF_WEIGHT_GET_COMPLETE,
							proc: 'Common_Unit_Of_Weight-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;




		////////////////////////////////////////////////////////////CONTROL TOWER SERVICES////////////////////////////////////////////////////////////////
		//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


		case ctrltwrtypes.CTRLTWR_GENERATE_PRO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_GENERATE_PRO_COMPLETE,
							proc: 'CtrlTwr_GeneratePro_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;



		case ctrltwrtypes.CTRLTWR_MODE_REF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_MODE_REF_COMPLETE,
							proc: 'CtrlTwr_ModeRef_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_AIRPORT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_AIRPORT_COMPLETE,
							proc: 'CtrlTwr_Airport_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_SEAPORT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SEAPORT_COMPLETE,
							proc: 'CtrlTwr_Seaport_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_COUNTRY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_COUNTRY_COMPLETE,
							proc: 'CtrlTwr_Country_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;



		case ctrltwrtypes.CTRLTWR_STATE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_STATE_COMPLETE,
							proc: 'CtrlTwr_State_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_MILESTONE_REF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_MILESTONE_REF_COMPLETE,
							proc: 'CtrlTwr_MilestoneRef_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_SHIPMENT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_COMPLETE,
							proc: 'CtrlTwr_Shipment_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.OriginCountryID + "," + action.payload.PO + "," + action.payload.ShipmentClosed + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.HotShipment + "," + action.payload.Subscription + "," + action.payload.LateShipment + "," + action.payload.ShipmentAlert
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_COMPLETE,
							proc: 'CtrlTwr_Shipment_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.CustomerID + "," + action.payload.OriginCountryID + "," + action.payload.PO + "," + action.payload.ETD + "," + action.payload.HotShipment + "," + action.payload.Pallets + "," + action.payload.Cases + "," + action.payload.UnitCount + "," + action.payload.WeightUnits + "," + action.payload.DestinationCountryID + "," + action.payload.SpecialRequirements + "," + action.payload.GrossWeight + "," + action.payload.ChargeableWeight + "," + action.payload.Length + "," + action.payload.Width + "," + action.payload.Height + "," + action.payload.DimUnits + "," + action.payload.Commodity
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.OriginCountryID + "," + action.payload.PO + "," + action.payload.ShipmentClosed + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.QuotingStatusID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.CustomerID + "," + action.payload.OriginCountryID + "," + action.payload.PO + "," + action.payload.ETD + "," + action.payload.HotShipment + "," + action.payload.Pallets + "," + action.payload.Cases + "," + action.payload.UnitCount + "," + action.payload.WeightUnits + "," + action.payload.DestinationCountryID + "," + action.payload.ShipmentQuoteActive + "," + action.payload.QuotingStatusID + "," + action.payload.SpecialRequirements + "," + action.payload.GrossWeight + "," + action.payload.ChargeableWeight + "," + action.payload.Length + "," + action.payload.Width + "," + action.payload.Height + "," + action.payload.DimUnits + "," + action.payload.Commodity
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_STATUS_ACTION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_STATUS_ACTION_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Status_Action_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.ShipmentQuoteActive + "," + action.payload.QuotingStatusID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_LEGS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_LEGS_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Legs_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LegID + "," + action.payload.DeleteLeg + "," + action.payload.ProRef + "," + action.payload.LegNumber + "," + action.payload.ModeID + "," + action.payload.Carrier + "," + action.payload.Shipper_Name + "," + action.payload.Origin_Name + "," + action.payload.Origin_AddressLine + "," + action.payload.Origin_City + "," + action.payload.Origin_State + "," + action.payload.Origin_PostalCode + "," + action.payload.Origin_CountryCode + "," + action.payload.Consignee_Name + "," + action.payload.Destination_Name + "," + action.payload.Destination_AddressLine + "," + action.payload.Destination_City + "," + action.payload.Destination_State + "," + action.payload.Destination_PostalCode + "," + action.payload.Destination_CountryCode
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_LEGS_QUOTE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_LEGS_QUOTE_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Legs_Quote_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_COMPLETE,
							proc: 'CtrlTwr_Quoting_Line_Item_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ModeID + "," + action.payload.QuoteLineItemID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_UOM_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_UOM_COMPLETE,
							proc: 'CtrlTwr_Quoting_Line_Item_UOM_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.QuoteLineItemUomID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_RATE_TYPE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_RATE_TYPE_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_RATE_TYPE_COMPLETE,
							proc: 'CtrlTwr_Quoting_Line_Item_Rate_Type_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.QuoteLineItemRateTypeID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_LEGS_LINE_ITEMS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_QUOTING_LINE_ITEM_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_LEGS_LINE_ITEMS_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Legs_Line_Item_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.LegID + "," + action.payload.LegLineItemID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_LEGS_LINE_ITEM_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_LEGS_LINE_ITEM_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_LEGS_LINE_ITEM_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Legs_Line_Item_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LegLineItemID + "," + action.payload.LegID + "," + action.payload.QuoteLineItemID + "," + action.payload.ProRef + "," + action.payload.LegNumber + "," + action.payload.ModeID + "," + action.payload.DeleteLineItem + "," + action.payload.SellRate + "," + action.payload.BuyRate + "," + action.payload.QuoteLineItemUom + "," + action.payload.QuoteLineItemRateType + "," + action.payload.LineItemNotes + "," + action.payload.LineItemSeq
						}
					]
				}
			)
			break;




		case ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_FILEUPLOAD_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_FileUpload-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.ProRef + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_QUOTING_SHIPMENT_FILEUPLOAD_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_FileUpload-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.ProRef + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete + "," + action.payload.MoveFileToCtrlTwr
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_NOTES_PRIVATE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_NOTES_PRIVATE_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Notes_Private_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentNoteID + "," + action.payload.ProRef
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_NOTES_PUBLIC_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_SHIPMENT_NOTES_PUBLIC_COMPLETE,
							proc: 'CtrlTwr_Quoting_Shipment_Notes_Public_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentNoteID + "," + action.payload.ProRef
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_QUOTING_REPORT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_QUOTING_REPORT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_QUOTING_REPORT_COMPLETE,
							proc: 'CtrlTwr_Quoting_Report_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.ShipmentClosed + "," + action.payload.QuotingStatusID
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_SHIPMENT_NOTES_PRIVATE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_NOTES_PRIVATE_COMPLETE,
							proc: 'CtrlTwr_Shipment_Notes_Private_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentNoteID + "," + action.payload.ProRef
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_NOTES_PRIVATE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_NOTES_PRIVATE_COMPLETE,
							proc: 'CtrlTwr_Shipment_Notes_Private_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentNoteID + "," + action.payload.ProRef + "," + action.payload.PrivateNote + "," + action.payload.Delete
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_SHIPMENT_NOTES_PUBLIC_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_NOTES_PUBLIC_COMPLETE,
							proc: 'CtrlTwr_Shipment_Notes_Public_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentNoteID + "," + action.payload.ProRef
						}
					]
				}
			)
			break;



		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_NOTES_PUBLIC_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_NOTES_PUBLIC_COMPLETE,
							proc: 'CtrlTwr_Shipment_Notes_Public_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentNoteID + "," + action.payload.ProRef + "," + action.payload.PublicNote + "," + action.payload.Delete
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_COMPLETE,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.LegNumber + "," + action.payload.ModeID + "," + action.payload.DataJson + "," + action.payload.LegID + "," + action.payload.DeleteLeg
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_DATA_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_DATA_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_Data_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_Data_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.LegNumber + "," + action.payload.ModeID + "," + action.payload.LegID + "," + action.payload.WarehouseID + "," + action.payload.BOL + "," + action.payload.MBOL + "," + action.payload.HBOL + "," + action.payload.PO + "," + action.payload.Container + "," + action.payload.Carrier + "," + action.payload.Seal + "," + action.payload.PlannedDepartureDate + "," + action.payload.EstimatedDeliveryDate + "," + action.payload.PickupAddress + "," + action.payload.DeliveryAddress + "," + action.payload.Trailer + "," + action.payload.Vessel + "," + action.payload.SeaportOriginID + "," + action.payload.SeaportDestID + "," + action.payload.Flight + "," + action.payload.AirportOriginID + "," + action.payload.AirportDestID + "," + action.payload.CustomerRef + "," + action.payload.Shipper_Name + "," + action.payload.Origin_AddressLine + "," + action.payload.Origin_City + "," + action.payload.Origin_State + "," + action.payload.Origin_PostalCode + "," + action.payload.Origin_CountryCode + "," + action.payload.Consignee_Name + "," + action.payload.Destination_AddressLine + "," + action.payload.Destination_City + "," + action.payload.Destination_State + "," + action.payload.Destination_PostalCode + "," + action.payload.Destination_CountryCode + "," + action.payload.PickupAppointmentTime + "," + action.payload.DeliveryAppointmentTime
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_MILESTONES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_MILESTONES_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_Milestones_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.LegID
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_MILESTONES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_MILESTONES_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_Milestones_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentLegMilestoneID + "," + action.payload.ProRef + "," + action.payload.LegID + "," + action.payload.ModeID + "," + action.payload.MilestoneID + "," + action.payload.MilestoneDT + "," + action.payload.MilestoneTimezone + "," + action.payload.CountryCodeID + "," + action.payload.City + "," + action.payload.State + "," + action.payload.Zip + "," + action.payload.SeaportCodeID + "," + action.payload.AirportCodeID + "," + action.payload.WarehouseID + "," + action.payload.DeleteMilestone + "," + action.payload.StateCodeID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_MILESTONES_MULTI_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_MILESTONES_MULTI_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_MILESTONES_MULTI_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_Milestones_Multi_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ShipmentLegMilestoneID + "," + action.payload.ProRef + "," + action.payload.LegIDs + "," + action.payload.ModeID + "," + action.payload.MilestoneID + "," + action.payload.MilestoneDT + "," + action.payload.MilestoneTimezone + "," + action.payload.CountryCodeID + "," + action.payload.City + "," + action.payload.State + "," + action.payload.Zip + "," + action.payload.SeaportCodeID + "," + action.payload.AirportCodeID + "," + action.payload.WarehouseID + "," + action.payload.DeleteMilestone + "," + action.payload.StateCodeID
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_MILESTONES_MULTI_DATA_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_MILESTONES_MULTI_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_MILESTONES_MULTI_DATA_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_Milestones_Multi_Data_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.PO + "," + action.payload.ShipmentClosed + "," + action.payload.ModeID + "," + action.payload.LegID + "," + action.payload.Container + "," + action.payload.Carrier + "," + action.payload.Seal + "," + action.payload.Trailer + "," + action.payload.Vessel + "," + action.payload.SeaportOriginID + "," + action.payload.SeaportDestID + "," + action.payload.Flight + "," + action.payload.AirportOriginID + "," + action.payload.AirportDestID + "," + action.payload.OriginCountryID
						}
					]
				}
			)
			break;



		case ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_CUSTOMERREF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_CUSTOMERREF_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_CustomerRef_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.LegID + "," + action.payload.HbolID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_PO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_PO_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_PO_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.LegID + "," + action.payload.HbolID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_HBOL_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_LEGS_HBOL_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_HBOL_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.LegID
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_CUSTOMERREF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_CUSTOMERREF_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_CustomerRef_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerRefID + "," + action.payload.LegID + "," + action.payload.HbolID + "," + action.payload.CustomerRef + "," + action.payload.Delete
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_HBOL_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_HBOL_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_HBOL_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HbolID + "," + action.payload.LegID + "," + action.payload.HBOL + "," + action.payload.Delete
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_PO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_PO_COMPLETE,
							proc: 'CtrlTwr_Shipment_Legs_PO_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HbolID + "," + action.payload.LegID + "," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.Delete
						}
					]
				}
			)
			break;



		case ctrltwrtypes.CTRLTWR_TIMEZONE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_TIMEZONE_COMPLETE,
							proc: 'CtrlTwr_Timezone_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_ALERTS_SHIPMENT_DEPARTURE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_ALERTS_SHIPMENT_DEPARTURE_COMPLETE,
							proc: 'CtrlTwr_Alerts_Shipment_Departure_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.OriginCountryID + "," + action.payload.PO + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.ShipmentClosed
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_ALERTS_SHIPMENT_DELIVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_ALERTS_SHIPMENT_DELIVERY_COMPLETE,
							proc: 'CtrlTwr_Alerts_Shipment_Delivery_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.OriginCountryID + "," + action.payload.PO + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.ShipmentClosed
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_ALERTS_SHIPMENT_SUMMARY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_ALERTS_SHIPMENT_SUMMARY_COMPLETE,
							proc: 'CtrlTwr_Alerts_Shipment_Summary_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.OriginCountryID + "," + action.payload.PO + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.ShipmentClosed
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_ALERTS_STATS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_ALERTS_STATS_COMPLETE,
							proc: 'CtrlTwr_Alerts_Stats_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.PO + "," + action.payload.ModeID + "," + action.payload.Carrier + "," + action.payload.OriginCountryID + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.ShipmentClosed + "," + action.payload.Filter
						}
					]
				}
			)
			break;



		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_HOTSHIPMENT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_HOTSHIPMENT_COMPLETE,
							proc: 'CtrlTwr_Shipment_HotShipment_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.HotShipment
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_USER_SUBSCRIPTION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_USER_SUBSCRIPTION_COMPLETE,
							proc: 'CtrlTwr_Shipment_User_Subscription_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ProRef + "," + action.payload.Active
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_COMPLETE,
							proc: 'CtrlTwr_Chart_Shipment_Delivery_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.PO + "," + action.payload.OriginCountryID + "," + action.payload.ModeID + "," + action.payload.Carrier + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.ShipmentClosed + "," + action.payload.HotShipment + "," + action.payload.Subscription + "," + action.payload.LateShipment + "," + action.payload.ShipmentAlert + "," + action.payload.ChartDetailData
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_DETAILS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_DETAILS_COMPLETE,
							proc: 'CtrlTwr_Chart_Shipment_Delivery_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.PO + "," + action.payload.OriginCountryID + "," + action.payload.ModeID + "," + action.payload.Carrier + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.ShipmentClosed + "," + action.payload.HotShipment + "," + action.payload.Subscription + "," + action.payload.LateShipment + "," + action.payload.ShipmentAlert + "," + action.payload.ChartDetailData
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_HISTORY_COMPLETE,
							proc: 'CtrlTwr_Chart_Shipment_Delivery_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.PO + "," + action.payload.OriginCountryID + "," + action.payload.ModeID + "," + action.payload.Carrier + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.HotShipment + "," + action.payload.Subscription + "," + action.payload.LateShipment + "," + action.payload.ShipmentAlert + "," + action.payload.ChartDetailData
						}
					]
				}
			)
			break;


		case ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_HISTORY_DETAILS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_CHART_SHIPMENT_DELIVERY_HISTORY_DETAILS_COMPLETE,
							proc: 'CtrlTwr_Chart_Shipment_Delivery_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ProRef + "," + action.payload.PO + "," + action.payload.OriginCountryID + "," + action.payload.ModeID + "," + action.payload.Carrier + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.HotShipment + "," + action.payload.Subscription + "," + action.payload.LateShipment + "," + action.payload.ShipmentAlert + "," + action.payload.ChartDetailData
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_SHIPMENT_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_SHIPMENT_FILEUPLOAD_COMPLETE,
							proc: 'CtrlTwr_Shipment_FileUpload_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.ProRef + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;

		case ctrltwrtypes.CTRLTWR_POST_SHIPMENT_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_GENERATE_PRO_ERROR,
							onComplete: ctrltwrtypes.CTRLTWR_POST_SHIPMENT_FILEUPLOAD_COMPLETE,
							proc: 'CtrlTwr_Shipment_FileUpload_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.ProRef + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;






		case ctrltwrtypes.EDI_990_QUEUE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.EDI_990_QUEUE_COMPLETE,
							proc: 'EDI_990_Queue_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.QueueStatus + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case ctrltwrtypes.EDI_POST_990_QUEUE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.EDI_POST_990_QUEUE_COMPLETE,
							proc: 'EDI_990_Queue_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.AcceptDecline + "," + action.payload.ID + "," + action.payload.HdrId204 + "," + action.payload.B101_SCAC + "," + action.payload.N902_ProRef + "," + action.payload.SE02_ControlNumber + "," + action.payload.QueueStatus
						}
					]
				}
			)
			break;


		case ctrltwrtypes.EDI_204_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.EDI_204_COMPLETE,
							proc: 'EDI_204_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HdrID + "," + action.payload.LoadTenderNo + "," + action.payload.CustomerID + "," + action.payload.QueueStatus + "," + action.payload.LoadDtStart + "," + action.payload.LoadDtEnd
						}
					]
				}
			)
			break;


		case ctrltwrtypes.EDI_204_OID_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.EDI_204_OID_COMPLETE,
							proc: 'EDI_204_OID_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HdrId + "," + action.payload.LoadTenderNo + "," + action.payload.ProRef
						}
					]
				}
			)
			break;


		case ctrltwrtypes.EDI_204_L5_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: ctrltwrtypes.ON_ERROR,
							//onError:  ctrltwrtypes.CTRLTWR_POST_SHIPMENT_LEGS_DATA_ERROR,
							onComplete: ctrltwrtypes.EDI_204_L5_COMPLETE,
							proc: 'EDI_204_L5_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HdrId + "," + action.payload.LoadTenderNo + "," + action.payload.ProRef
						}
					]
				}
			)
			break;






		////////////////////////////////////////////////////////////VAS EXTERNAL API SERVICES////////////////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



		case vastypes.CUSTOMS_CITY_API_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.CustomsCityAPI,
							next,
							// onError: vastypes.ON_ERROR,
							onError: vastypes.CUSTOMS_CITY_API_ERROR,
							onComplete: vastypes.CUSTOMS_CITY_API_COMPLETE,
							proc: '',
							paramvalue: action.payload.paramHouse + "," + action.payload.paramMaster + "," + action.payload.getOnly
						}
					]
				}
			)
			break;






		////////////////////////////////////////////////////////////VAS SERVICES////////////////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


		case vastypes.DASHBOARD_SUMMARY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.DASHBOARD_SUMMARY_ERROR,
							onComplete: vastypes.DASHBOARD_SUMMARY_COMPLETE,
							proc: 'XDock_Dashboard_Summary_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.WarehousePort + "," + action.payload.ConsigneeID + "," + action.payload.DestinationID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case vastypes.CUSTOMS_CITY_MESSAGES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.CUSTOMS_CITY_MESSAGES_ERROR,
							onComplete: vastypes.CUSTOMS_CITY_MESSAGES_COMPLETE,
							proc: 'XDock_Customs_City_Messages_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HouseID + "," + action.payload.HouseRef + "," + action.payload.MasterID + "," + action.payload.Master
						}
					]
				}
			)
			break;


		case vastypes.MAWB_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.MAWB_ERROR,
							onComplete: vastypes.MAWB_COMPLETE,
							proc: 'XDock_MAWB_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.MinETADischargeStart + "," + action.payload.MinETADischargeEnd + "," + action.payload.CarrierName + "," + action.payload.MawbStatusID + "," + action.payload.WarehouseID + "," + action.payload.OrderNo + "," + action.payload.PlannedPickupStart + "," + action.payload.PlannedPickupEnd + "," + action.payload.AssignedDriver + "," + action.payload.MawbColorCode + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.POST_MAWB_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_MAWB_ERROR,
							onComplete: vastypes.POST_MAWB_COMPLETE,
							proc: 'XDock_MAWB_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.TotCartons + "," + action.payload.TotWeight + "," + action.payload.TotChargeable + "," + action.payload.TotVolume + "," + action.payload.MinETADischarge + "," + action.payload.CarrierName + "," + action.payload.FlightVoyage + "," + action.payload.AgentNote + "," + action.payload.CurrentMawbStatusID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ExpectedCartons
						}
					]
				}
			)
			break;

		case vastypes.POST_MAWB_EVOLVE_DATA_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_MAWB_EVOLVE_DATA_ERROR,
							onComplete: vastypes.POST_MAWB_EVOLVE_DATA_COMPLETE,
							proc: 'XDock_MAWB_EvolveDataEntry_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.No + "," + action.payload.PMC + "," + action.payload.PickupBy + "," + action.payload.Trips + "," + action.payload.ArrivalTime + "," + action.payload.LFD + "," + action.payload.ArrivalAtWarehouse + "," + action.payload.DeliveryTime + "," + action.payload.Notes + "," + action.payload.Recovered + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case vastypes.POST_MAWB_ADD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_MAWB_ADD_ERROR,
							onComplete: vastypes.POST_MAWB_ADD_COMPLETE,
							proc: 'XDock_MAWB_Add_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.MAWB_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.MAWB_RECOVERY_ERROR,
							onComplete: vastypes.MAWB_RECOVERY_COMPLETE,
							proc: 'XDock_MAWB_Recovery_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.POST_MAWB_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_MAWB_RECOVERY_ERROR,
							onComplete: vastypes.POST_MAWB_RECOVERY_COMPLETE,
							proc: 'XDock_MAWB_Recovery_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.PlannedPickupDT + "," + action.payload.DriverAssigned + "," + action.payload.Note + "," + action.payload.TripMade + "," + action.payload.FreightRecovered + "," + action.payload.PickupDT + "," + action.payload.CartonsRecovered + "," + action.payload.PickedUpBy + "," + action.payload.Carrier + "," + action.payload.LFD + "," + action.payload.PMC + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.POST_MAWB_PICKUP_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_MAWB_RECOVERY_ERROR,
							onComplete: vastypes.POST_MAWB_RECOVERY_COMPLETE,
							proc: 'Transportation_MAWB_Pickup_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.PlannedPickupDT + "," + action.payload.DriverAssigned + "," + action.payload.Note + "," + action.payload.TripMade + "," + action.payload.FreightRecovered + "," + action.payload.PickupDT + "," + action.payload.CartonsRecovered + "," + action.payload.PickedUpBy + "," + action.payload.Carrier + "," + action.payload.LFD + "," + action.payload.PMC + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PartialPickup
						}
					]
				}
			)
			break;

		case vastypes.MAWB_STATUS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.MAWB_STATUS_ERROR,
							onComplete: vastypes.MAWB_STATUS_COMPLETE,
							proc: 'XDock_MAWB_Status_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case vastypes.POST_MAWB_STATUS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_MAWB_STATUS_ERROR,
							onComplete: vastypes.POST_MAWB_STATUS_COMPLETE,
							proc: 'XDock_MAWB_Status_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.MawbStatusID + "," + action.payload.MawbStatusName + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.MAWB_CARRIER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.MAWB_CARRIER_ERROR,
							onComplete: vastypes.MAWB_CARRIER_COMPLETE,
							proc: 'XDock_MAWB_CarrierRef_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;

		case vastypes.HAWB_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.HAWB_ERROR,
							onComplete: vastypes.HAWB_COMPLETE,
							proc: 'XDock_HAWB_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HouseID + "," + action.payload.HouseRef + "," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.ShipmentETDStart + "," + action.payload.ShipmentETDEnd + "," + action.payload.Origin + "," + action.payload.LastDischargePort + "," + action.payload.ETADischargeStart + "," + action.payload.ETADischargeEnd + "," + action.payload.EstCartageDeliveryStart + "," + action.payload.EstCartageDeliveryEnd + "," + action.payload.ActualCartageDeliveryStart + "," + action.payload.ActualCartageDeliveryEnd + "," + action.payload.HawbStatusID + "," + action.payload.ConsigneeID + "," + action.payload.Destination + "," + action.payload.WarehouseID + "," + action.payload.WarehousePort + "," + action.payload.OrderNo + "," + action.payload.CustomerID + "," + action.payload.CustomsCategoryID
						}
					]
				}
			)
			break;


		case vastypes.HAWB_T86_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.HAWB_ERROR,
							onComplete: vastypes.HAWB_T86_COMPLETE,
							proc: 'XDock_HAWB_T86Grouping_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HouseID + "," + action.payload.HouseRef + "," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.ShipmentETDStart + "," + action.payload.ShipmentETDEnd + "," + action.payload.Origin + "," + action.payload.LastDischargePort + "," + action.payload.ETADischargeStart + "," + action.payload.ETADischargeEnd + "," + action.payload.EstCartageDeliveryStart + "," + action.payload.EstCartageDeliveryEnd + "," + action.payload.ActualCartageDeliveryStart + "," + action.payload.ActualCartageDeliveryEnd + "," + action.payload.HawbStatusID + "," + action.payload.ConsigneeID + "," + action.payload.Destination + "," + action.payload.WarehouseID + "," + action.payload.WarehousePort + "," + action.payload.OrderNo + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;




		case vastypes.XDOCK_HAWB_T86LIST_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: vastypes.ON_ERROR,
							onComplete: vastypes.XDOCK_HAWB_T86LIST_GET_COMPLETE,
							proc: 'XDock_HAWB_T86List_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.MawbList
						}
					]
				}
			)
			break;



		case vastypes.POST_HAWB_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_HAWB_ERROR,
							onComplete: vastypes.POST_HAWB_COMPLETE,
							proc: 'XDock_HAWB_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.HouseRef + "," + action.payload.ConsigneeName + "," + action.payload.ConsigneeID + "," + action.payload.Notes + "," + action.payload.Origin + "," + action.payload.HAWBDestination + "," + action.payload.LastDischargePort + "," + action.payload.DeliverToAddress + "," + action.payload.Orders + "," + action.payload.ShipmentETD + "," + action.payload.EstCartageDelivery + "," + action.payload.ETADischarge + "," + action.payload.ActualCartageDelivery + "," + action.payload.Cartons + "," + action.payload.NewPallets + "," + action.payload.Weight + "," + action.payload.Chargeable + "," + action.payload.Volume + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;



		case vastypes.HAWB_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.HAWB_RECOVERY_ERROR,
							onComplete: vastypes.HAWB_RECOVERY_COMPLETE,
							proc: 'XDock_HAWB_Recovery_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HouseID + "," + action.payload.HouseRef + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case vastypes.POST_HAWB_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_HAWB_RECOVERY_ERROR,
							onComplete: vastypes.POST_HAWB_RECOVERY_COMPLETE,
							proc: 'XDock_HAWB_Recovery_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.HouseID + "," + action.payload.HouseRef + "," + action.payload.RecoveredPCS + "," + action.payload.Pallets + "," + action.payload.Notes + "," + action.payload.CustomsCleared + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.XDOCK_POST_HAWB_RECOVERED_SHORT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.HAWB_RECOVERY_ERROR,
							onComplete: vastypes.XDOCK_POST_HAWB_RECOVERED_SHORT_COMPLETE,
							proc: 'XDock_HAWB_Recovered_Short_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.TotalPCS + "," + action.payload.RecoveredPCS + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.HAWB_CONSIGNEE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.HAWB_CONSIGNEE_ERROR,
							onComplete: vastypes.HAWB_CONSIGNEE_COMPLETE,
							proc: 'XDock_HAWB_Consignee_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.HAWB_DESTINATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.HAWB_DESTINATION_ERROR,
							onComplete: vastypes.HAWB_DESTINATION_COMPLETE,
							proc: 'XDock_HAWB_Destination_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HawbStatusID
						}
					]
				}
			)
			break;

		case vastypes.LOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.LOAD_ERROR,
							onComplete: vastypes.LOAD_COMPLETE,
							proc: 'XDock_Load_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.HouseID + "," + action.payload.MasterID + "," + action.payload.PickupDateStart + "," + action.payload.PickupDateEnd + "," + action.payload.DeliveryDateStart + "," + action.payload.DeliveryDateEnd + "," + action.payload.LoadStatusID + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.ConsigneeID + "," + action.payload.DestinationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.LOAD_HAWB_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.LOAD_HAWB_ERROR,
							onComplete: vastypes.LOAD_HAWB_COMPLETE,
							proc: 'XDock_LoadHAWB_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.HouseID + "," + action.payload.MasterID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case vastypes.POST_LOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_LOAD_ERROR,
							onComplete: vastypes.POST_LOAD_COMPLETE,
							proc: 'XDock_Load_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.PickupDate + "," + action.payload.DeliveryDate + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.TotalPCS + "," + action.payload.TotalPallets + "," + action.payload.LoadStatusID + "," + action.payload.LoadHawbData + "," + action.payload.HouseID + "," + action.payload.PCS + "," + action.payload.Pallets + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.MC + "," + action.payload.DOT + "," + action.payload.Driver + "," + action.payload.Truck + "," + action.payload.TruckPlate + "," + action.payload.TrailerPlate + "," + action.payload.Notes
						}
					]
				}
			)
			break;


		case vastypes.POST_LOAD_REMOVE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_LOAD_REMOVE_ERROR,
							onComplete: vastypes.POST_LOAD_REMOVE_COMPLETE,
							proc: 'XDock_Load_Remove_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.HouseID + "," + action.payload.PCS + "," + action.payload.Pallets + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case vastypes.POST_LOAD_EDIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_LOAD_REMOVE_ERROR,
							onComplete: vastypes.POST_LOAD_EDIT_COMPLETE,
							proc: 'XDock_Load_Edit_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.HouseID + "," + action.payload.PCS + "," + action.payload.Pallets + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case vastypes.LOAD_HAWB_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.LOAD_HAWB_HISTORY_ERROR,
							onComplete: vastypes.LOAD_HAWB_HISTORY_COMPLETE,
							proc: 'XDock_Load_HAWB_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HouseID + "," + action.payload.LoadID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case vastypes.OUTBOUND_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.OUTBOUND_ERROR,
							onComplete: vastypes.OUTBOUND_COMPLETE,
							proc: 'XDock_Outbound_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.HouseID + "," + action.payload.HouseRef + "," + action.payload.MasterID + "," + action.payload.Master + "," + action.payload.OrderNo + "," + action.payload.DepartDateStart + "," + action.payload.DepartDateEnd + "," + action.payload.DestinationID + "," + action.payload.DestinationName + "," + action.payload.DCCode + "," + action.payload.Carrier + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.BOL + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;





		case vastypes.POST_USER_COLOR_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError: vastypes.POST_USER_COLOR_ERROR,
							onComplete: vastypes.POST_USER_COLOR_COMPLETE,
							proc: 'XDock_MAWB_UserColor_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MasterID + "," + action.payload.MawbColorCode + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;



		case vastypes.XDOCK_MAWB_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_MAWB_FILEUPLOAD_COMPLETE,
							proc: 'XDock_MAWB_FileUpload_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.MasterID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;

		case vastypes.XDOCK_POST_MAWB_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_POST_MAWB_FILEUPLOAD_COMPLETE,
							proc: 'XDock_MAWB_FileUpload_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.MasterID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;





		case vastypes.XDOCK_LOAD_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_LOAD_FILEUPLOAD_COMPLETE,
							proc: 'XDock_Load_FileUpload_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.LoadID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;

		case vastypes.XDOCK_POST_LOAD_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_POST_LOAD_FILEUPLOAD_COMPLETE,
							proc: 'XDock_Load_FileUpload_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.LoadID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;


		case vastypes.XDOCK_TRINITY_DATA_FILE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_TRINITY_DATA_FILE_GET_COMPLETE,
							proc: 'XDock_Trinity_Data_File_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.TrinityDataFileID + "," + action.payload.MasterID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete + "," + action.payload.StartDT + "," + action.payload.EndDT
						}
					]
				}
			)
			break;


		case vastypes.XDOCK_TRINITY_DATA_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_TRINITY_DATA_GET_COMPLETE,
							proc: 'XDock_Trinity_Data_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.WarehouseID + "," + action.payload.TrinityDataID + "," + action.payload.Master + "," + action.payload.HouseRef + "," + action.payload.HAWBDestination + "," + action.payload.ConsigneeName + "," + action.payload.ETALastDischargeStartDT + "," + action.payload.ETALastDischargeEndDT
						}
					]
				}
			)
			break;




		case vastypes.XDOCK_LOAD_PALLET_CARTON_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_LOAD_PALLET_CARTON_GET_COMPLETE,
							proc: 'XDock_Load_Pallet_Carton_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.LoadPalletID + "," + action.payload.LoadPalletCartonID
						}
					]
				}
			)
			break;


		case vastypes.XDOCK_LOAD_PALLET_CARTON_POST:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_LOAD_PALLET_CARTON_POST_COMPLETE,
							proc: 'XDock_Load_Pallet_Carton_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadPalletCartonID + "," + action.payload.LoadPalletID + "," + action.payload.LoadID + "," + action.payload.HouseID + "," + action.payload.CartonID + "," + action.payload.CartonQty + "," + action.payload.Delete
						}
					]
				}
			)
			break;



		case vastypes.XDOCK_LOAD_PALLET_POST:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_LOAD_PALLET_POST_COMPLETE,
							proc: 'XDock_Load_Pallet_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadPalletID + "," + action.payload.LoadID + "," + action.payload.HouseID + "," + action.payload.PalletSeq + "," + action.payload.Delete
						}
					]
				}
			)
			break;





		case vastypes.XDOCK_LOAD_PALLET_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_LOAD_PALLET_GET_COMPLETE,
							proc: 'XDock_Load_Pallet_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.LoadPalletID
						}
					]
				}
			)
			break;


		case vastypes.XDOCK_CUSTOMS_CITY_MANIFEST_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_GENERATE_PRO_ERROR,
							onComplete: vastypes.XDOCK_CUSTOMS_CITY_MANIFEST_HISTORY_GET_COMPLETE,
							proc: 'XDock_Customs_City_Manifest_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CCManifestPostID + "," + action.payload.MasterID + "," + action.payload.BOLNumber + "," + action.payload.HouseID + "," + action.payload.houseBOLNumber
						}
					]
				}
			)
			break;





		case vastypes.XDOCK_MAWB_CARRIERREF_POST:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: vastypes.ON_ERROR,
							//onError:  vastypes.XDOCK_MAWB_CARRIERREF_POST_ERROR,
							onComplete: vastypes.XDOCK_MAWB_CARRIERREF_POST_COMPLETE,
							proc: 'XDock_MAWB_CarrierRef_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CarrierID + "," + action.payload.CarrierName + "," + action.payload.Delete
						}
					]
				}
			)
			break;





		////////////////////////////////////////////////////////////TRANS SERVICES////////////////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


		case transtypes.TRANS_CONSIGNEE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							//onError: transtypes.HAWB_CONSIGNEE_ERROR,
							onComplete: transtypes.TRANS_CONSIGNEE_COMPLETE,
							proc: 'Trans_Consignee_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;




		case transtypes.TRANS_CUSTOMERREF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							//onError: transtypes.HAWB_CONSIGNEE_ERROR,
							onComplete: transtypes.TRANS_CUSTOMERREF_COMPLETE,
							proc: 'Trans_CustomerRef_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case transtypes.TRANS_PROJECT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							//onError: transtypes.HAWB_CONSIGNEE_ERROR,
							onComplete: transtypes.TRANS_PROJECT_COMPLETE,
							proc: 'Trans_Project_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case transtypes.TRANS_DESTINATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							//onError: transtypes.HAWB_CONSIGNEE_ERROR,
							onComplete: transtypes.TRANS_DESTINATION_COMPLETE,
							proc: 'Trans_Destination_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case transtypes.CONTAINER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.CONTAINER_COMPLETE,
							proc: 'Trans_Container_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.ContainerStatusID + "," + action.payload.LCLFCL + "," + action.payload.DeliveryAppointmentStart + "," + action.payload.DeliveryAppointmentEnd + "," + action.payload.ReceivedDTStart + "," + action.payload.ReceivedDTEnd + "," + action.payload.EtdStart + "," + action.payload.EtdEnd + "," + action.payload.EtaStart + "," + action.payload.EtaEnd + "," + action.payload.MbolID + "," + action.payload.MBOL + "," + action.payload.HbolID + "," + action.payload.HBOL + "," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case transtypes.POST_CONTAINER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.POST_CONTAINER_COMPLETE,
							proc: 'Trans_Container_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.LCLFCL + "," + action.payload.DeliveryAppointment + "," + action.payload.ETD + "," + action.payload.ETA + "," + action.payload.CurrentContainerStatusID + "," + action.payload.Notes + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case transtypes.CONTAINER_JSON_TREE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.CONTAINER_JSON_TREE_COMPLETE,
							proc: 'Trans_Container_JsonTree_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.MbolID + "," + action.payload.MBOL + "," + action.payload.HbolID + "," + action.payload.HBOL + "," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case transtypes.TRANS_CONTAINER_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_CONTAINER_HISTORY_COMPLETE,
							proc: 'Trans_Container_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.Container
						}
					]
				}
			)
			break;


		case transtypes.SHIPMENT_RECEIVE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.SHIPMENT_RECEIVE_COMPLETE,
							proc: 'Trans_ShipmentReceive_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.MbolID + "," + action.payload.HbolID + "," + action.payload.PoID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case transtypes.POST_SHIPMENT_RECEIVE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.POST_SHIPMENT_RECEIVE_COMPLETE,
							proc: 'Trans_ShipmentReceive_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.MbolID + "," + action.payload.HbolID + "," + action.payload.PoID + "," + action.payload.CaseCountExpected + "," + action.payload.CasesReceived + "," + action.payload.Pallets + "," + action.payload.Notes + "," + action.payload.CustomsCleared + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;



		case transtypes.POST_MBOL_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.POST_MBOL_COMPLETE,
							proc: 'Trans_MBOL_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.MbolID + "," + action.payload.MBOL + "," + action.payload.ContainerID + "," + action.payload.Delete + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;



		case transtypes.POST_HBOL_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.POST_HBOL_COMPLETE,
							proc: 'Trans_HBOL_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.HbolID + "," + action.payload.HBOL + "," + action.payload.MbolID + "," + action.payload.Delete + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case transtypes.TRANS_LOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_LOAD_COMPLETE,
							proc: 'Trans_Load_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.LoadStatusID + "," + action.payload.ContainerID + "," + action.payload.MbolID + "," + action.payload.HbolID + "," + action.payload.PoID + "," + action.payload.CustomerRefID + "," + action.payload.PickupDateStart + "," + action.payload.PickupDateEnd + "," + action.payload.DeliveryDateStart + "," + action.payload.DeliveryDateEnd + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal
						}
					]
				}
			)
			break;


		case transtypes.TRANS_POST_LOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_POST_LOAD_COMPLETE,
							proc: 'Trans_Load_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.PickupDate + "," + action.payload.DeliveryDate + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.TotalPCS + "," + action.payload.TotalPallets + "," + action.payload.Destination + "," + action.payload.LoadStatusID + "," + action.payload.LoadPoData + "," + action.payload.LocationPoData + "," + action.payload.PoID + "," + action.payload.PCS + "," + action.payload.Pallets + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case transtypes.TRANS_POST_LOAD_REMOVE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_POST_LOAD_REMOVE_COMPLETE,
							proc: 'Trans_Load_Remove_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.PoID + "," + action.payload.PCS + "," + action.payload.Pallets + "," + action.payload.WarehouseLocations + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;


		case transtypes.TRANS_LOAD_PO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_LOAD_PO_COMPLETE,
							proc: 'Trans_Load_Po_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID
						}
					]
				}
			)
			break;


		case transtypes.TRANS_LOAD_PO_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_LOAD_PO_HISTORY_COMPLETE,
							proc: 'Trans_Load_PO_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.PoID + "," + action.payload.LoadID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;



		case transtypes.TRANS_OUTBOUND_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_OUTBOUND_COMPLETE,
							proc: 'Trans_Outbound_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.MbolID + "," + action.payload.MBOL + "," + action.payload.HbolID + "," + action.payload.HBOL + "," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.DepartDateStart + "," + action.payload.DepartDateEnd + "," + action.payload.DestinationID + "," + action.payload.DestinationName + "," + action.payload.Seal + "," + action.payload.Carrier + "," + action.payload.Trailer + "," + action.payload.BOL
						}
					]
				}
			)
			break;

		case transtypes.PO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.PO_COMPLETE,
							proc: 'Trans_PO_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.MbolID + "," + action.payload.MBOL + "," + action.payload.HbolID + "," + action.payload.HBOL + "," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.ContainerStatusID + "," + action.payload.PoStatusID + "," + action.payload.CustomerRefID + "," + action.payload.CustomerRef + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd
						}
					]
				}
			)
			break;




		case transtypes.POST_PO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.POST_PO_COMPLETE,
							proc: 'Trans_PO_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.HbolID + "," + action.payload.CustomerRef + "," + action.payload.CaseCount + "," + action.payload.PalletCount + "," + action.payload.Notes + "," + action.payload.Project + "," + action.payload.Delete + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case transtypes.TRANS_PO_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_PO_LOCATION_COMPLETE,
							proc: 'Trans_PO_Location_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.MbolID + "," + action.payload.MBOL + "," + action.payload.HbolID + "," + action.payload.HBOL + "," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.PoStatusID + "," + action.payload.CustomerRefID + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case transtypes.TRANS_POST_PO_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_POST_PO_LOCATION_COMPLETE,
							proc: 'Trans_PO_Location_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.PoID + "," + action.payload.WarehouseLocationID + "," + action.payload.Cases + "," + action.payload.Pallets + "," + action.payload.PreviousWarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.Oversize
						}
					]
				}
			)
			break;

		case transtypes.TRANS_PO_LOAD_LOCATION_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_PO_LOAD_LOCATION_HISTORY_COMPLETE,
							proc: 'Trans_PO_Load_Location_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.PoID + "," + action.payload.PO
						}
					]
				}
			)
			break;

		case transtypes.PO_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.PO_RECOVERY_COMPLETE,
							proc: 'Trans_PO_Recovery_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.MbolID + "," + action.payload.MBOL + "," + action.payload.HbolID + "," + action.payload.HBOL + "," + action.payload.PoID + "," + action.payload.PO + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case transtypes.TRANS_PO_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							onComplete: transtypes.TRANS_PO_HISTORY_COMPLETE,
							proc: 'Trans_PO_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PoID + "," + action.payload.PO
						}
					]
				}
			)
			break;






		case transtypes.TRANS_CONTAINER_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							//onError:  transtypes.TRANS_GENERATE_PRO_ERROR,
							onComplete: transtypes.TRANS_CONTAINER_FILEUPLOAD_COMPLETE,
							proc: 'Trans_Container_FileUpload_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.ContainerID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;

		case transtypes.TRANS_POST_CONTAINER_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: transtypes.ON_ERROR,
							//onError:  transtypes.TRANS_GENERATE_PRO_ERROR,
							onComplete: transtypes.TRANS_POST_CONTAINER_FILEUPLOAD_COMPLETE,
							proc: 'Trans_Container_FileUpload_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.ContainerID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;
















		////////////////////////////////////////////////////////////LABEL GENERATION SERVICES////////////////////////////////////////////////////////////////
		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


		// case labelgentypes.LABELGEN_API_REQUEST_MAIN_GET:
		// 	getAPIData({
		// 		type: 'series',
		// 		data: [
		// 			{
		// 				type: 'post',
		// 				endpoint: appAPI.API.data.LabelGenRequestMain,
		// 				next,
		// 				onError: labelgentypes.LABELGEN_API_REQUEST_MAIN_ERROR,
		// 				onComplete: labelgentypes.LABELGEN_API_REQUEST_MAIN_COMPLETE,
		// 				authToken: action.payload.authToken,
		// 				paramvalue: action.payload.param
		// 			}
		// 		]
		// 	}
		// 	)
		// 	break;


		case labelgentypes.LABELGEN_API_REQUEST_MAIN_GET:
			getData({
				type: 'series',
				data: [
					{
						type: 'post',
						endpoint: appAPI.API.data.LabelGenRequestMain,
						next,
						onError: labelgentypes.LABELGEN_API_REQUEST_MAIN_ERROR,
						onComplete: labelgentypes.LABELGEN_API_REQUEST_MAIN_COMPLETE,
						proc: 'LabelGen_Request_Get', //DON'T TYPE WebApp_
						paramvalue: action.payload.param

					}
				]
			}
			)
			break;






		case labelgentypes.LABELGEN_REQUEST_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_REQUEST_ERROR,
							onComplete: labelgentypes.LABELGEN_REQUEST_COMPLETE,
							proc: 'LabelGen_Request_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.CarrierID + "," + action.payload.LabelRequestID + "," + action.payload.ResponseSuccess + "," + action.payload.RequestDtStart + "," + action.payload.RequestDtEnd + "," + action.payload.ProdEnvironment + "," + action.payload.LabelPortID
						}
					]
				}
			)
			break;


		case labelgentypes.LABELGEN_RESPONSE_PACKAGE_LABELS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_RESPONSE_PACKAGE_LABELS_ERROR,
							onComplete: labelgentypes.LABELGEN_RESPONSE_PACKAGE_LABELS_COMPLETE,
							proc: 'LabelGen_Response_Package_Labels_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.CarrierID + "," + action.payload.LabelRequestID + "," + action.payload.ResponseSuccess + "," + action.payload.RequestDtStart + "," + action.payload.RequestDtEnd + "," + action.payload.ProdEnvironment + "," + action.payload.LabelPortID + "," + action.payload.TrackingNumber + "," + action.payload.ShipmentIdentificationNumber
						}
					]
				}
			)
			break;



		case labelgentypes.LABELGEN_REQUEST_INWORK_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_REQUEST_INWORK_ERROR,
							onComplete: labelgentypes.LABELGEN_REQUEST_INWORK_COMPLETE,
							proc: 'LabelGen_Request_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.CarrierID + "," + action.payload.LabelRequestID + "," + action.payload.ResponseSuccess + "," + action.payload.RequestDtStart + "," + action.payload.RequestDtEnd + "," + action.payload.ProdEnvironment + "," + action.payload.LabelPortID
						}
					]
				}
			)
			break;




		case labelgentypes.LABELGEN_REQUEST_PACKAGE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_REQUEST_PACKAGE_ERROR,
							onComplete: labelgentypes.LABELGEN_REQUEST_PACKAGE_COMPLETE,
							proc: 'LabelGen_Request_Package_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.RequestPackageID + "," + action.payload.LabelRequestID
						}
					]
				}
			)
			break;


		case labelgentypes.LABELGEN_POST_REQUEST_PACKAGE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_POST_REQUEST_PACKAGE_ERROR,
							onComplete: labelgentypes.LABELGEN_POST_REQUEST_PACKAGE_COMPLETE,
							proc: 'LabelGen_Request_Package_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.RequestPackageID + "," + action.payload.LabelRequestID + "," + action.payload.PackageIndex + "," + action.payload.Package_Description + "," + action.payload.Package_Packaging_Code + "," + action.payload.Package_Dimensions_UOM_Code + "," + action.payload.Package_Dimensions_Length + "," + action.payload.Package_Dimensions_Width + "," + action.payload.Package_Dimensions_Height + "," + action.payload.Package_PackageWeight_UOM_Code + "," + action.payload.Package_PackageWeight_UOM_Description + "," + action.payload.Package_PackageWeight_Weight + "," + action.payload.Package_PkgSO_DeliveryConfirmation_DCISType + "," + action.payload.Package_PkgSO_DeclaredValue_CurrencyCode + "," + action.payload.Package_PkgSO_DeclaredValue_MonetaryValue + "," + action.payload.Delete
						}
					]
				}
			)
			break;


		case labelgentypes.LABELGEN_REQUEST_PACKAGE_PRODUCTINFO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_REQUEST_PACKAGE_PRODUCTINFO_ERROR,
							onComplete: labelgentypes.LABELGEN_REQUEST_PACKAGE_PRODUCTINFO_COMPLETE,
							proc: 'LabelGen_Request_Package_ProductInfo_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.RequestProductInfoID + "," + action.payload.RequestPackageID + "," + action.payload.LabelRequestID
						}
					]
				}
			)
			break;




		case labelgentypes.LABELGEN_POST_REQUEST_PACKAGE_PRODUCTINFO_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_POST_REQUEST_PACKAGE_PRODUCTINFO_ERROR,
							onComplete: labelgentypes.LABELGEN_POST_REQUEST_PACKAGE_PRODUCTINFO_COMPLETE,
							proc: 'LabelGen_Request_Package_ProductInfo_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.RequestProductInfoID + "," + action.payload.RequestPackageID + "," + action.payload.PackageIndex + "," + action.payload.LabelRequestID + "," + action.payload.ProductInfoIndex + "," + action.payload.ProductCode + "," + action.payload.ProductDescription + "," + action.payload.ProductUnitValue + "," + action.payload.CurrencyCode + "," + action.payload.ProductItemOrigin + "," + action.payload.ProductHarmonizedCode + "," + action.payload.ProductUnitWeight + "," + action.payload.ProductQuantity + "," + action.payload.ProductFabricContent + "," + action.payload.Hazmat + "," + action.payload.HazmatCode + "," + action.payload.FDAFlag + "," + action.payload.FDACode + "," + action.payload.Delete
						}
					]
				}
			)
			break;



		case labelgentypes.LABELGEN_POST_REQUEST_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_POST_REQUEST_ERROR,
							onComplete: labelgentypes.LABELGEN_POST_REQUEST_COMPLETE,
							proc: 'LabelGen_Request_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LabelRequestID + "," + action.payload.CustomerID + "," + action.payload.WarehouseID + "," + action.payload.CarrierID + "," + action.payload.ProdEnvironment + "," + action.payload.RequestDT + "," + action.payload.ResponseSuccess + "," + action.payload.Shipper_Name + "," + action.payload.Shipper_AttentionName + "," + action.payload.Shipper_CompanyDisplayableName + "," + action.payload.Shipper_TaxIdentificationNumber + "," + action.payload.Shipper_Phone_Number + "," + action.payload.Shipper_Phone_Extension + "," + action.payload.Shipper_ShipperNumber + "," + action.payload.Shipper_FaxNumber + "," + action.payload.Shipper_EMailAddress + "," + action.payload.Shipper_Address_AddressLine1 + "," + action.payload.Shipper_Address_AddressLine2 + "," + action.payload.Shipper_Address_AddressLine3 + "," + action.payload.Shipper_Address_City + "," + action.payload.Shipper_Address_StateProvinceCode + "," + action.payload.Shipper_Address_PostalCode + "," + action.payload.Shipper_Address_CountryCode + "," + action.payload.ShipTo_Name + "," + action.payload.ShipTo_AttentionName + "," + action.payload.ShipTo_CompanyDisplayableName + "," + action.payload.ShipTo_TaxIdentificationNumber + "," + action.payload.ShipTo_Phone_Number + "," + action.payload.ShipTo_Phone_Extension + "," + action.payload.ShipTo_FaxNumber + "," + action.payload.ShipTo_EMailAddress + "," + action.payload.ShipTo_AddressLine1 + "," + action.payload.ShipTo_AddressLine2 + "," + action.payload.ShipTo_AddressLine3 + "," + action.payload.ShipTo_Address_City + "," + action.payload.ShipTo_Address_StateProvinceCode + "," + action.payload.ShipTo_Address_PostalCode + "," + action.payload.ShipTo_Address_CountryCode + "," + action.payload.ShipFrom_Name + "," + action.payload.ShipFrom_AttentionName + "," + action.payload.ShipFrom_CompanyDisplayableName + "," + action.payload.ShipFrom_TaxIdentificationNumber + "," + action.payload.ShipFrom_Phone_Number + "," + action.payload.ShipFrom_Phone_Extension + "," + action.payload.ShipFrom_FaxNumber + "," + action.payload.ShipFrom_Address_AddressLine1 + "," + action.payload.ShipFrom_Address_AddressLine2 + "," + action.payload.ShipFrom_Address_AddressLine3 + "," + action.payload.ShipFrom_Address_City + "," + action.payload.ShipFrom_Address_StateProvinceCode + "," + action.payload.ShipFrom_Address_PostalCode + "," + action.payload.ShipFrom_Address_CountryCode + "," + action.payload.CarrierServiceID + "," + action.payload.LabelSpec_LabelImageFormat_Code + "," + action.payload.LabelSpec_LabelStockSize_Height + "," + action.payload.LabelSpec_LabelStockSize_Width + "," + action.payload.Delete + "," + action.payload.LabelPortID
						}
					]
				}
			)
			break;

		case labelgentypes.LABELGEN_CUSTOMERWAREHOUSE_DEFAULTVALUES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_CUSTOMERWAREHOUSE_USERSAVEDVALUES_ERROR,
							onComplete: labelgentypes.LABELGEN_CUSTOMERWAREHOUSE_DEFAULTVALUES_COMPLETE,
							proc: 'LabelGen_Request_CustomerWarehouse_DefaultValues_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.WarehouseID + "," + action.payload.DefaultValuesID + "," + action.payload.LabelPortID
						}
					]
				}
			)
			break;


		case labelgentypes.LABELGEN_PORT_REF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_PORT_REF_COMPLETE,
							onComplete: labelgentypes.LABELGEN_PORT_REF_COMPLETE,
							proc: 'LabelGen_Port_Ref_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LabelPortID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case labelgentypes.LABELGEN_CUSTOMERWAREHOUSE_USERSAVEDVALUES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_CUSTOMERWAREHOUSE_USERSAVEDVALUES_ERROR,
							onComplete: labelgentypes.LABELGEN_CUSTOMERWAREHOUSE_USERSAVEDVALUES_COMPLETE,
							proc: 'LabelGen_Request_CustomerWarehouse_UserSavedValues_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CustomerID + "," + action.payload.WarehouseID + "," + action.payload.CarrierID + "," + action.payload.UserSavedValuesID + "," + action.payload.ProdEnvironment
						}
					]
				}
			)
			break;

		case labelgentypes.LABELGEN_POST_CUSTOMERWAREHOUSE_USERSAVEDVALUES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ON_ERROR,
							//onError: labelgentypes.LABELGEN_POST_CUSTOMERWAREHOUSE_USERSAVEDVALUES_ERROR,
							onComplete: labelgentypes.LABELGEN_POST_CUSTOMERWAREHOUSE_USERSAVEDVALUES_COMPLETE,
							proc: 'LabelGen_Request_CustomerWarehouse_UserSavedValues_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.UserSavedValuesID + "," + action.payload.CustomerID + "," + action.payload.WarehouseID + "," + action.payload.CarrierID + "," + action.payload.Shipper_Name + "," + action.payload.Shipper_AttentionName + "," + action.payload.Shipper_CompanyDisplayableName + "," + action.payload.Shipper_TaxIdentificationNumber + "," + action.payload.Shipper_Phone_Number + "," + action.payload.Shipper_Phone_Extension + "," + action.payload.Shipper_ShipperNumber + "," + action.payload.Shipper_FaxNumber + "," + action.payload.Shipper_EMailAddress + "," + action.payload.Shipper_Address_AddressLine1 + "," + action.payload.Shipper_Address_AddressLine2 + "," + action.payload.Shipper_Address_AddressLine3 + "," + action.payload.Shipper_Address_City + "," + action.payload.Shipper_Address_StateProvinceCode + "," + action.payload.Shipper_Address_PostalCode + "," + action.payload.Shipper_Address_CountryCode + "," + action.payload.ShipFrom_Name + "," + action.payload.ShipFrom_AttentionName + "," + action.payload.ShipFrom_CompanyDisplayableName + "," + action.payload.ShipFrom_TaxIdentificationNumber + "," + action.payload.ShipFrom_Phone_Number + "," + action.payload.ShipFrom_Phone_Extension + "," + action.payload.ShipFrom_FaxNumber + "," + action.payload.ShipFrom_Address_AddressLine1 + "," + action.payload.ShipFrom_Address_AddressLine2 + "," + action.payload.ShipFrom_Address_AddressLine3 + "," + action.payload.ShipFrom_Address_City + "," + action.payload.ShipFrom_Address_StateProvinceCode + "," + action.payload.ShipFrom_Address_PostalCode + "," + action.payload.ShipFrom_Address_CountryCode + "," + action.payload.ProdEnvironment + "," + action.payload.LabelSpec_LabelImageFormat_Code + "," + action.payload.LabelSpec_LabelStockSize_Height + "," + action.payload.LabelSpec_LabelStockSize_Width + "," + action.payload.PrinterIP + "," + action.payload.PrinterPort + "," + action.payload.CarrierServiceID + "," + action.payload.Delete
						}
					]
				}
			)
			break;






		case labelgentypes.LABELGEN_EXTERNAL_UPS_TRACKING_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcDirectlyToS3, //Download To S3 Proc
							next,
							onError: labelgentypes.ON_ERROR,
							onComplete: labelgentypes.LABELGEN_EXTERNAL_UPS_TRACKING_COMPLETE,
							proc: 'LabelGen_External_UPS_Tracking-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ExternalUserID + "," + action.payload.TrackingNoList + "," + action.payload.SINList + "," + action.payload.USPSPICList + "," + action.payload.InTransit

						}
					]
				}
			)
			break;



		case labelgentypes.LABELGEN_EXTERNAL_DOWNLOAD_TRACKING_FILE_S3_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.FileDownloadAPI, ////***************This is specific to file download****************
							next,
							onError: labelgentypes.LABELGEN_EXTERNAL_DOWNLOAD_TRACKING_FILE_S3_ERROR,
							onComplete: labelgentypes.LABELGEN_EXTERNAL_DOWNLOAD_TRACKING_FILE_S3_COMPLETE,
							proc: action.payload.S3Bucket,
							paramvalue: action.payload.ObjectName + "," + action.payload.FilenameToSave
						}
					]
				}
			)
			break;







		// case labelgentypes.LABELGEN_POST_UPS_LABEL_CREATE_GET:
		// 	getData(
		// 		{
		// 			type: 'series',
		// 			data: [
		// 				{
		// 					type: 'post',
		// 					endpoint: appAPI.API.data.API_ups_api_label_creation,
		// 					next,
		// 					onError: labelgentypes.ON_ERROR,
		// 					//onError: labelgentypes.LABELGEN_POST_UPS_LABEL_CREATE_ERROR,
		// 					onComplete: labelgentypes.LABELGEN_POST_UPS_LABEL_CREATE_COMPLETE,
		// 					proc: 'Trans_Consignee_Get', //DON'T TYPE WebApp_
		// 					paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.labelParam
		// 				}
		// 			]
		// 		}
		// 	)
		// 	break;



		case labelgentypes.SHIP_REQUEST_GET:
			getAPIData({
				type: 'series',
				data: [
					{
						type: 'post',
						endpoint: appAPI.API.data.API_Evolve_TMS_Ship_Request,
						next,
						onError: labelgentypes.SHIP_REQUEST_ERROR,
						onComplete: labelgentypes.SHIP_REQUEST_COMPLETE,
						authToken: action.payload.authToken,
						paramvalue: action.payload.param
					}
				]
			}
			)
			break;

		case labelgentypes.BULK_SHIP_REQUEST_GET:
			getAPIData({
				type: 'series',
				data: [
					{
						type: 'post',
						endpoint: appAPI.API.data.API_Evolve_TMS_Ship_Request,
						next,
						onError: labelgentypes.BULK_SHIP_REQUEST_ERROR,
						onComplete: labelgentypes.BULK_SHIP_REQUEST_COMPLETE,
						authToken: action.payload.authToken,
						paramvalue: action.payload.param
					}
				]
			}
			)
			break;


		case labelgentypes.GET_LABEL_CREATE_HISTORY:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: labelgentypes.ERROR_LABEL_CREATE_HISTORY,
							onComplete: labelgentypes.COMPLETE_LABEL_CREATE_HISTORY,
							proc: 'TMS_Ship_Request_GetLabelCreateHistory', //Don't type "WebApp"
							paramvalue: appSettings.tmsDB + ",'" + action.payload.user + "', " + action.payload.RequestID + ", " + action.payload.RequestUserID + ", " + action.payload.Environment + ", " + action.payload.StatusCode + ", " + action.payload.UniqueKey_ParcelID + ", " + action.payload.MasterCartonID_ContainerID + ", " + action.payload.OrderInfo_OrderNo + ", " + action.payload.OrderInfo_OrderDate + ", " + action.payload.EvolveCustomerInfo_CustomerName + ", " + action.payload.ShipToInfo_State + ", " + action.payload.ShipToInfo_Postcode + ", " + action.payload.ShipToInfo_CountryCode + ", " + action.payload.API + ", " + action.payload.Carrier + ", " + action.payload.Service + ", " + action.payload.TrackingNumber + ", " + action.payload.LabelCreateStartDT + ", " + action.payload.LabelCreateEndDT + ", " + action.payload.FlatsFlag + ", " + action.payload.PrintUserID + ", " + action.payload.PrintStartDT + ", " + action.payload.PrintEndDT + ", " + action.payload.Printed + ", " + action.payload.filter
						}
					]
				}
			)
			break;






		////////////////////////////////////////////////////////////INVENTORY SERVICES////////////////////////////////////////////////////////////////
		//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////		


		case inventorytypes.INVENTORY_DESTINATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_DESTINATION_COMPLETE,
							proc: 'Inventory_Destination_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		// this needs to be compressed 

		case inventorytypes.INVENTORY_CUSTOMERREF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CUSTOMERREF_COMPLETE,
							proc: 'Inventory_CustomerRef_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_PROJECT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_PROJECT_COMPLETE,
							proc: 'Inventory_Project_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_SKU_COMPLETE,
							proc: 'InventoryLot_SKU-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.SkuStatusID + "," + action.payload.WarehouseLocationID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_COMPLETE,
							proc: 'Inventory_SKU_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.SkuStatusID + "," + action.payload.WarehouseLocationID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_POST_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_SKU_COMPLETE,
							proc: 'Inventory_SKU_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.ContainerID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.CurrentSkuStatusID + "," + action.payload.CustomerRefID + "," + action.payload.CustomerRef + "," + action.payload.ProjectID + "," + action.payload.Project + "," + action.payload.Notes
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_CONTAINER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_CONTAINER_COMPLETE,
							proc: 'InventoryLot_Container-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.ContainerStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.WarehouseLocationID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_CONTAINER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CONTAINER_COMPLETE,
							proc: 'Inventory_Container_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.ContainerStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.WarehouseLocationID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_POST_CONTAINER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_CONTAINER_COMPLETE,
							proc: 'Inventory_Container_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.LCL_FCL + "," + action.payload.DeliveryAppointment + "," + action.payload.ETD + "," + action.payload.ETA + "," + action.payload.CurrentContainerStatusID + "," + action.payload.Notes + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.Palletized
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_POST_CONTAINER_GET2:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_CONTAINER_COMPLETE2,
							proc: 'Inventory_Container_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.LCL_FCL + "," + action.payload.DeliveryAppointment + "," + action.payload.ETD + "," + action.payload.ETA + "," + action.payload.CurrentContainerStatusID + "," + action.payload.Notes + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.Palletized
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_POST_CONTAINER_STATUS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_CONTAINER_STATUS_COMPLETE,
							proc: 'Inventory_Container_Status_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.ContainerStatusID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_CONTAINER_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CONTAINER_HISTORY_COMPLETE,
							proc: 'Inventory_Container_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.SkuID + "," + action.payload.SKU
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_CONTAINER_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CONTAINER_SKU_COMPLETE,
							proc: 'Inventory_Container_SKU_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.SkuID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_POST_CONTAINER_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_CONTAINER_SKU_COMPLETE,
							proc: 'Inventory_Container_SKU_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.Units + "," + action.payload.Cases + "," + action.payload.Pallets + "," + action.payload.Delete + "," + action.payload.CustomerRefID + "," + action.payload.CustomerRef + "," + action.payload.ProjectID + "," + action.payload.Project + "," + action.payload.Notes
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_SKU_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_RECOVERY_COMPLETE,
							proc: 'Inventory_SKU_Recovery_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.ContainerID + "," + action.payload.Container
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_SKU_RECOVERY_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_RECOVERY_HISTORY_COMPLETE,
							proc: 'Inventory_SKU_Recovery_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.ContainerID + "," + action.payload.Container
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_POST_SKU_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_SKU_RECOVERY_COMPLETE,
							proc: 'Inventory_SKU_Recovery_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.SkuID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.SkuDescription + "," + action.payload.UnitsReceived + "," + action.payload.CasesReceived + "," + action.payload.PalletsReceived + "," + action.payload.Oversize + "," + action.payload.CustomsCleared + "," + action.payload.RecoveryDate
						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_SKU_WAREHOUSE_LOC_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //needs to stay on this proc
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_WAREHOUSE_LOC_COMPLETE,
							proc: 'Inventory_SKU_Warehouse_Location_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.SkuStatusID + "," + action.payload.WarehouseLocationID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_POST_SKU_WAREHOUSE_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_SKU_WAREHOUSE_LOCATION_COMPLETE,
							proc: 'Inventory_SKU_Warehouse_Location_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.SkuID + "," + action.payload.SkuWarehouseLocationID + "," + action.payload.WarehouseLocationID + "," + action.payload.Units + "," + action.payload.Cases + "," + action.payload.Pallets + "," + action.payload.Oversize + "," + action.payload.PreviousWarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuRecovery + "," + action.payload.RecoveryContainerID + "," + action.payload.RecoveryDate + "," + action.payload.SkuDescription
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_SKU_WAREHOUSE_LOCATION_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_WAREHOUSE_LOCATION_HISTORY_COMPLETE,
							proc: 'Inventory_SKU_Warehouse_Location_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.SkuStatusID + "," + action.payload.WarehouseLocationID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_WAREHOUSE_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_WAREHOUSE_LOCATION_COMPLETE,
							proc: 'Inventory_Warehouse_Location_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.WarehouseLocationID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_COMPLETE,
							proc: 'Inventory_Load_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.LoadStatusID + "," + action.payload.ContainerID + "," + action.payload.SkuID + "," + action.payload.CustomerRefID + "," + action.payload.PickupDateStart + "," + action.payload.PickupDateEnd + "," + action.payload.DeliveryDateStart + "," + action.payload.DeliveryDateEnd + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.DestinationID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_POST_LOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_LOAD_COMPLETE,
							proc: 'Inventory_Load_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.LoadID + "," + action.payload.PickupDate + "," + action.payload.DeliveryDate + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.TotalUnits + "," + action.payload.TotalCases + "," + action.payload.TotalPallets + "," + action.payload.Destination + "," + action.payload.DestinationID + "," + action.payload.LoadStatusID + "," + action.payload.LoadSkuData + "," + action.payload.LocationSkuData + "," + action.payload.WarehouseLocationID + "," + action.payload.SkuWarehouseLocationID + "," + action.payload.LoadSkuID + "," + action.payload.SkuID + "," + action.payload.Units + "," + action.payload.Cases + "," + action.payload.Pallets + "," + action.payload.Oversize + "," + action.payload.WarehouseID + "," + action.payload.CustomerID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_POST_LOAD_REMOVE_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_LOAD_REMOVE_SKU_COMPLETE,
							proc: 'Inventory_Load_Remove_SKU_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadSkuID + "," + action.payload.LoadID + "," + action.payload.SkuID + "," + action.payload.Units + "," + action.payload.Cases + "," + action.payload.Pallets + "," + action.payload.Oversize + "," + action.payload.WarehouseLocationID + "," + action.payload.SkuWarehouseLocationID + "," + action.payload.WarehouseLocations
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOAD_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_SKU_COMPLETE,
							proc: 'Inventory_Load_SKU_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.SkuID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOAD_SKU_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_SKU_HISTORY_COMPLETE,
							proc: 'Inventory_Load_SKU_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.SkuID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOAD_SKU_LOCATION_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_SKU_LOCATION_HISTORY_COMPLETE,
							proc: 'Inventory_Load_SKU_Location_History_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.SkuID + "," + action.payload.Oversize
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_OUTBOUND_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_OUTBOUND_COMPLETE,
							proc: 'Inventory_Outbound_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.DepartDateStart + "," + action.payload.DepartDateEnd + "," + action.payload.DestinationID + "," + action.payload.DestinationName + "," + action.payload.Seal + "," + action.payload.Carrier + "," + action.payload.Trailer + "," + action.payload.BOL
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_REPORTING_INBOUND_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_REPORTING_INBOUND_COMPLETE,
							proc: 'Inventory_Reporting_Inbound_Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.ContainerStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.StartRecoveryDt + "," + action.payload.EndRecoveryDt

						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_REPORTING_STORAGE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							// endpoint: appAPI.API.data.WebAppRunProcCompressed,
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_REPORTING_STORAGE_COMPLETE,
							proc: 'Inventory_Reporting_Storage_Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.StartDT + "," + action.payload.EndDT

						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_POST_RECOVERY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_RECOVERY_COMPLETE,
							proc: 'Inventory_Recovery-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.DataJson + "," + action.payload.ContainerID + "," + action.payload.CustomsCleared + "," + action.payload.Palletized + "," + action.payload.RecoveryDate
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_SKU_WAREHOUSE_LOCATION_GROUPED_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_WAREHOUSE_LOCATION_GROUPED_COMPLETE,
							proc: 'Inventory_SKU_Warehouse_Location_Grouped-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseSku + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd + "," + action.payload.CaseOrUnitSkuID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_SKU_WAREHOUSE_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_WAREHOUSE_LOCATION_COMPLETE,
							proc: 'Inventory_SKU_Warehouse_Location-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseSku + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd + "," + action.payload.CaseOrUnitSkuID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_UNIT_WAREHOUSE_LOCATION_GROUPED_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_UNIT_WAREHOUSE_LOCATION_GROUPED_COMPLETE,
							proc: 'InventoryLot_Unit_Warehouse_Location_Grouped-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseSku + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd + "," + action.payload.CaseOrUnitSkuID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_CASE_WAREHOUSE_LOCATION_GROUPED_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CASE_WAREHOUSE_LOCATION_GROUPED_COMPLETE,
							proc: 'InventoryLot_Case_Warehouse_Location_Grouped-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_CASE_WAREHOUSE_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CASE_WAREHOUSE_LOCATION_COMPLETE,
							proc: 'Inventory_Case_Warehouse_Location-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd
						}
					]
				}
			)
			break;




		case inventorytypes.INVENTORY_POST_CASE_WAREHOUSE_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_CASE_WAREHOUSE_LOCATION_COMPLETE,
							proc: 'Inventory_Case_Warehouse_Location-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.NewPalletID + "," + action.payload.NewPalletBarcode + "," + action.payload.CaseIdList
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_GROUPED_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_GROUPED_COMPLETE,
							proc: 'InventoryLot_Pallet_Warehouse_Location_Grouped-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd + "," + action.payload.PalletOversize
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_COMPLETE,
							proc: 'Inventory_Pallet_Warehouse_Location-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd + "," + action.payload.PalletOversize
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_GET2:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_COMPLETE2,
							proc: 'Inventory_Pallet_Warehouse_Location-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseLocationID + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletStatusID + "," + action.payload.CaseStatusID + "," + action.payload.SkuStatusID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.RecoveryDateStart + "," + action.payload.RecoveryDateEnd + "," + action.payload.PalletOversize
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_POST_PALLET_WAREHOUSE_LOCATION_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_PALLET_WAREHOUSE_LOCATION_COMPLETE,
							proc: 'Inventory_Pallet_Warehouse_Location-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.NewWarehouseLocationID + "," + action.payload.Departed + "," + action.payload.PalletStatusID + "," + action.payload.Oversize + "," + action.payload.NewWarehouseLocationBarcode + "," + action.payload.NewWarehouseLocationBarcodeNoSpaces + "," + action.payload.PalletIdList
						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_POST_LOAD_PALLET_CASE_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_LOAD_PALLET_CASE_SKU_COMPLETE,
							proc: 'Inventory_Load_Pallet_Case_SKU-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.DataJson + "," + action.payload.DataType + "," + action.payload.LoadID + "," + action.payload.PickupDate + "," + action.payload.DeliveryDate + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.TotalUnits + "," + action.payload.TotalCases + "," + action.payload.TotalPallets + "," + action.payload.Destination + "," + action.payload.DestinationID + "," + action.payload.LoadStatusID + "," + action.payload.OrderOutboundID + "," + action.payload.MC + "," + action.payload.DOT + "," + action.payload.Driver + "," + action.payload.Truck + "," + action.payload.TruckPlate + "," + action.payload.TrailerPlate + "," + action.payload.Notes
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOAD_PALLET_CASE_UNIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_PALLET_CASE_UNIT_COMPLETE,
							proc: 'Inventory_Load_Pallet_Case_Unit-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.SkuID + "," + action.payload.CaseSkuID
						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_LOAD_LOT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_LOT_COMPLETE,
							proc: 'Inventory_Load_Lot-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.LoadStatusID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseSku + "," + action.payload.CaseLotCode + "," + action.payload.CaseSerialNumber + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber + "," + action.payload.CustomerRefID + "," + action.payload.PickupDateStart + "," + action.payload.PickupDateEnd + "," + action.payload.DeliveryDateStart + "," + action.payload.DeliveryDateEnd + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.DestinationID + "," + action.payload.OrderOutboundID
						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_PALLET_CONTENTS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_PALLET_CONTENTS_COMPLETE,
							proc: 'Inventory_Pallet_Contents-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.PalletID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_POST_LOAD_BARCODE_SCAN_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_LOAD_BARCODE_SCAN_COMPLETE,
							proc: 'Inventory_Load_Barcode_Scan-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletData + "," + action.payload.CaseData + "," + action.payload.UnitData + "," + action.payload.LoadID + "," + action.payload.PickupDate + "," + action.payload.DeliveryDate + "," + action.payload.Carrier + "," + action.payload.BOL + "," + action.payload.Trailer + "," + action.payload.Seal + "," + action.payload.TotalUnits + "," + action.payload.TotalCases + "," + action.payload.TotalPallets + "," + action.payload.Destination + "," + action.payload.DestinationID + "," + action.payload.LoadStatusID + "," + action.payload.MC + "," + action.payload.DOT + "," + action.payload.Driver + "," + action.payload.Truck + "," + action.payload.TruckPlate + "," + action.payload.TrailerPlate + "," + action.payload.Notes
						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_POST_PALLET_CREATE_NEW_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_PALLET_CREATE_NEW_COMPLETE,
							proc: 'Inventory_Pallet_Create_New-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.DataJson + "," + action.payload.WarehouseLocationID + "," + action.payload.Oversize + "," + action.payload.Notes
						}
					]
				}
			)
			break;





		case inventorytypes.INVENTORY_SKU_REF_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_SKU_REF_COMPLETE,
							proc: 'Inventory_SKU_Ref-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuStatusID + "," + action.payload.ProjectID + "," + action.payload.SkuLotCode + "," + action.payload.SkuSerialNumber
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_CASE_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CASE_HISTORY_COMPLETE,
							proc: 'Inventory_Case_History-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.ContainerID
						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_CASE_SKUS_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_CASE_SKUS_HISTORY_COMPLETE,
							proc: 'Inventory_Case_SKUs_History-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.UnitSkuID + "," + action.payload.ContainerID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOAD_CASES_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_CASES_HISTORY_COMPLETE,
							proc: 'Inventory_Load_Cases_History-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOAD_PALLETS_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_PALLETS_HISTORY_COMPLETE,
							proc: 'Inventory_Load_Pallets_History-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOAD_SKUS_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOAD_SKUS_HISTORY_COMPLETE,
							proc: 'Inventory_Load_SKUs_History-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.UnitSkuID
						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_PALLET_WAREHOUSE_LOCATION_HISTORY_COMPLETE,
							proc: 'Inventory_Pallet_Warehouse_Location_History-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.ContainerID
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_POST_LOAD_REMOVE_PALLET_CASE_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_POST_LOAD_REMOVE_PALLET_CASE_SKU_COMPLETE,
							proc: 'Inventory_Load_Remove_Pallet_Case_SKU-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.NewPalletID + "," + action.payload.CaseSkuID + "," + action.payload.UnitsToRemove + "," + action.payload.NewCaseID + "," + action.payload.DeleteLoad
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_BARCODE_SCAN_VALIDATE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_BARCODE_SCAN_VALIDATE_COMPLETE,
							proc: 'InventoryLot_Barcode_Scan_Validate-Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.Barcode
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_OUTBOUND_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_OUTBOUND_COMPLETE,
							proc: 'InventoryLot_Outbound-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.LoadID + "," + action.payload.DepartDateStart + "," + action.payload.DepartDateEnd + "," + action.payload.DestinationID + "," + action.payload.DestinationName + "," + action.payload.Seal + "," + action.payload.Carrier + "," + action.payload.Trailer + "," + action.payload.BOL + "," + action.payload.CaseSku + "," + action.payload.UnitSKU + "," + action.payload.CaseOrUnitSKU + "," + action.payload.CaseOrUnitSkuID

						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_REPORTING_INBOUND_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_REPORTING_INBOUND_COMPLETE,
							proc: 'InventoryLot_Reporting_Inbound-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.ContainerStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.StartRecoveryDt + "," + action.payload.EndRecoveryDt

						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_LOT_REPORTING_STORAGE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_REPORTING_STORAGE_COMPLETE,
							proc: 'InventoryLot_Reporting_Storage-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.StartDT + "," + action.payload.EndDT

						}
					]
				}
			)
			break;




		case inventorytypes.INVENTORY_LOT_HISTORY_TYPE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_HISTORY_TYPE_COMPLETE,
							proc: 'InventoryLot_HistoryType-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.InventoryDelete

						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_POST_DELETE_CONTAINER_PALLET_CASE_UNIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_POST_DELETE_CONTAINER_PALLET_CASE_UNIT_COMPLETE,
							proc: 'InventoryLot_Delete_Container_Pallet_Case_Unit-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.HistoryTypeID + "," + action.payload.ContainerIdList + "," + action.payload.PalletIdList + "," + action.payload.PalletBarcode + "," + action.payload.CaseIdList + "," + action.payload.CaseBarcode + "," + action.payload.UnitIdList + "," + action.payload.UnitsToRemove
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_POST_CASE_REF_EDIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_POST_CASE_REF_EDIT_COMPLETE,
							proc: 'InventoryLot_Case_Ref_Edit-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.SKU + "," + action.payload.SkuID + "," + action.payload.Notes + "," + action.payload.LotCode + "," + action.payload.SerialNumber + "," + action.payload.CustomerRefID + "," + action.payload.CustomerRef + "," + action.payload.ProjectID + "," + action.payload.Project
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_POST_UNIT_CASESKU_REF_EDIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_POST_UNIT_CASESKU_REF_EDIT_COMPLETE,
							proc: 'InventoryLot_Unit_CaseSku_Ref_Edit-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CaseSkuID + "," + action.payload.SKU + "," + action.payload.SkuID + "," + action.payload.LotCode + "," + action.payload.SerialNumber + "," + action.payload.CustomerRefID + "," + action.payload.CustomerRef + "," + action.payload.ProjectID + "," + action.payload.Project + "," + action.payload.UnitsRecovered + "," + action.payload.Notes
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_POST_PALLET_REF_EDIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_POST_PALLET_REF_EDIT_COMPLETE,
							proc: 'InventoryLot_Pallet_Ref_Edit-Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.Notes + "," + action.payload.Oversize + "," + action.payload.Length + "," + action.payload.Width + "," + action.payload.RecoveryDateEdit
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_POST_CONTAINER_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_POST_CONTAINER_COMPLETE,
							proc: 'InventoryLot_Container-Post', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.Container + "," + action.payload.LCL_FCL + "," + action.payload.DeliveryAppointment + "," + action.payload.ETD + "," + action.payload.ETA + "," + action.payload.CurrentContainerStatusID + "," + action.payload.Notes + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.Palletized + "," + action.payload.ContainerSize
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_POST:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_POST_COMPLETE,
							proc: 'InventoryLot_Order_Outbound-Post', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.OrderOutboundID + "," + action.payload.OrderRef + "," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrderStatusID + "," + action.payload.OrderTypeID + "," + action.payload.OrderDate + "," + action.payload.ShipByDate + "," + action.payload.DeliverByDate + "," + action.payload.ShipToName + "," + action.payload.ShipToAddressLine1 + "," + action.payload.ShipToAddressLine2 + "," + action.payload.ShipToCity + "," + action.payload.ShipToState + "," + action.payload.ShipToZip + "," + action.payload.ShipToCountry + "," + action.payload.OrderPriorityID + "," + action.payload.Notes + "," + action.payload.Delete
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_POST:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_POST_COMPLETE,
							proc: 'InventoryLot_Order_Outbound_SKU-Post', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrderOutboundID + "," + action.payload.OrderOutboundSkuID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.UomID + "," + action.payload.Qty + "," + action.payload.LotCode + "," + action.payload.SerialNumber + "," + action.payload.CustomerRefID + "," + action.payload.CustomerRef + "," + action.payload.ProjectID + "," + action.payload.Project + "," + action.payload.Notes + "," + action.payload.Delete
						}
					]
				}
			)
			break;




		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_GET_COMPLETE,
							proc: 'InventoryLot_Order_Outbound-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrderOutboundID + "," + action.payload.OrderRef + "," + action.payload.OrderStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.WarehouseLocationID

						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_GET_COMPLETE,
							proc: 'InventoryLot_Order_Outbound_SKU-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrderOutboundID + "," + action.payload.OrderRef + "," + action.payload.OrderStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.WarehouseLocationID

						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_EACH_LOCATIONS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_EACH_LOCATIONS_GET_COMPLETE,
							proc: 'InventoryLot_Order_Outbound_SKU_Each_Locations-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrderOutboundID + "," + action.payload.OrderRef + "," + action.payload.OrderStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.WarehouseLocationID + "," + action.payload.UomID

						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_CASE_LOCATIONS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_CASE_LOCATIONS_GET_COMPLETE,
							proc: 'InventoryLot_Order_Outbound_SKU_Case_Locations-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrderOutboundID + "," + action.payload.OrderRef + "," + action.payload.OrderStatusID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.WarehouseLocationID + "," + action.payload.UomID

						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_PALLET_SKU_UNITS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_PALLET_SKU_UNITS_GET_COMPLETE,
							proc: 'InventoryLot_Pallet_SKU_Units-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.PalletID

						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_PALLET_SKU_CASES_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_PALLET_SKU_CASES_GET_COMPLETE,
							proc: 'InventoryLot_Pallet_SKU_Cases-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.ContainerID + "," + action.payload.PalletID

						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_CASE_SKU_UNITS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_CASE_SKU_UNITS_GET_COMPLETE,
							proc: 'InventoryLot_Case_SKU_Units-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.CaseID + "," + action.payload.CaseBarcode

						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_PALLET_LOCATIONS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_SKU_PALLET_LOCATIONS_GET_COMPLETE,
							proc: 'InventoryLot_Order_Outbound_SKU_Pallet_Locations-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.OrderOutboundID + "," + action.payload.OrderRef + "," + action.payload.PalletID + "," + action.payload.PalletBarcode

						}
					]
				}
			)
			break;



		case inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_ORDER_OUTBOUND_HISTORY_GET_COMPLETE,
							proc: 'InventoryLot_Order_Outbound_History-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.OrderOutboundID

						}
					]
				}
			)
			break;






		case inventorytypes.INVENTORY_LOT_LOAD_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							//onError:  inventorytypes.INVENTORY_LOT_GENERATE_PRO_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_LOAD_FILEUPLOAD_COMPLETE,
							proc: 'InventoryLot_Load_FileUpload_Get', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.LoadID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_POST_LOAD_FILEUPLOAD_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							//onError:  inventorytypes.INVENTORY_LOT_GENERATE_PRO_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_POST_LOAD_FILEUPLOAD_COMPLETE,
							proc: 'InventoryLot_Load_FileUpload_Post', //DON'T TYPE WebApp_
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.FileUploadID + "," + action.payload.LoadID + "," + action.payload.FileName + "," + action.payload.S3FileName + "," + action.payload.FileType + "," + action.payload.FileDelete
						}
					]
				}
			)
			break;




		case inventorytypes.INVENTORY_LOT_SKU_INBOUND_RECEIPTS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed, //Compressed API, update reducer
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_SKU_INBOUND_RECEIPTS_GET_COMPLETE,
							proc: 'InventoryLot_SKU_Inbound_Receipts-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.PalletID + "," + action.payload.PalletBarcode + "," + action.payload.CaseID + "," + action.payload.CaseBarcode + "," + action.payload.CaseSkuID + "," + action.payload.CaseSku

						}
					]
				}
			)
			break;





		case inventorytypes.INVENTORY_LOT_SKU_REF_POST:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_SKU_REF_POST_COMPLETE,
							proc: 'InventoryLot_SKU_Ref-Post', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID + "," + action.payload.SKU + "," + action.payload.SkuStatusID + "," + action.payload.ProjectID + "," + action.payload.Project + "," + action.payload.CustomerRefID + "," + action.payload.CustomerRef + "," + action.payload.Notes + "," + action.payload.ProductName + "," + action.payload.ProductDetails + "," + action.payload.ProductURL + "," + action.payload.ProductCountryofOrigin + "," + action.payload.HTSCode + "," + action.payload.PGAFlag + "," + action.payload.TransactionID + "," + action.payload.UPC + "," + action.payload.PrimUomID + "," + action.payload.PackUnitID + "," + action.payload.PackingUomQty + "," + action.payload.Length + "," + action.payload.Width + "," + action.payload.Height + "," + action.payload.UomID + "," + action.payload.Weight + "," + action.payload.UowID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_SKU_REF_HISTORY_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_SKU_REF_HISTORY_GET_COMPLETE,
							proc: 'InventoryLot_SKU_Ref_History-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.SkuID
						}
					]
				}
			)
			break;


		case inventorytypes.INVENTORY_LOT_COMMON_PRIMARY_UOM_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_COMMON_PRIMARY_UOM_GET_COMPLETE,
							proc: 'InventoryLot_Common_Primary_UOM-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;

		case inventorytypes.INVENTORY_LOT_COMMON_PACKAGING_UNIT_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcCompressed,
							next,
							onError: inventorytypes.ON_ERROR,
							onComplete: inventorytypes.INVENTORY_LOT_COMMON_PACKAGING_UNIT_GET_COMPLETE,
							proc: 'InventoryLot_Common_Packaging_Unit-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'"
						}
					]
				}
			)
			break;






		////////////////////////////////////////////////////////////VISIBILITY SERVICES////////////////////////////////////////////////////////////////
		//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////		


		case visibilitytypes.VISIBILITY_DASHBOARD_STATS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.WebAppRunProcToS3, //Download To S3 Proc
							next,
							onError: visibilitytypes.ON_ERROR,
							onComplete: visibilitytypes.VISIBILITY_DASHBOARD_STATS_COMPLETE,
							proc: 'Visibility_Dashboard_Stats-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PackageID + "," + action.payload.DateStart + "," + action.payload.DateEnd
						}
					]
				}
			)
			break;

		case visibilitytypes.VISIBILITY_DASHBOARD_PACKAGE_LIST_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: visibilitytypes.ON_ERROR,
							onComplete: visibilitytypes.VISIBILITY_DASHBOARD_PACKAGE_LIST_COMPLETE,
							proc: 'Visibility_Dashboard_Package_List-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.WarehouseID + "," + action.payload.CustomerID + "," + action.payload.PackageID + "," + action.payload.TrackingNo + "," + action.payload.DateStart + "," + action.payload.DateEnd + "," + action.payload.AddressUpdate + "," + action.payload.TransitException + "," + action.payload.DeliveryException + "," + action.payload.Delivered + "," + action.payload.Damaged + "," + action.payload.InsufficientAdd + "," + action.payload.RTS
						}
					]
				}
			)
			break;

		case visibilitytypes.VISIBILITY_PACKAGE_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: visibilitytypes.ON_ERROR,
							onComplete: visibilitytypes.VISIBILITY_PACKAGE_COMPLETE,
							proc: 'Visibility_Package-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.PackageID
						}
					]
				}
			)
			break;

		case visibilitytypes.VISIBILITY_PACKAGE_UPS_EVENTS_GET:
			getData(
				{
					type: 'series',
					data: [
						{
							type: 'post',
							endpoint: appAPI.API.data.API_RunStoredProc,
							next,
							onError: visibilitytypes.ON_ERROR,
							onComplete: visibilitytypes.VISIBILITY_PACKAGE_UPS_EVENTS_COMPLETE,
							proc: 'Visibility_Package_UPS_Events-Get', //DON'T TYPE WebApp_
							user: action.payload.email,
							paramvalue: "'" + action.payload.email + "','" + action.payload.authToken + "'," + action.payload.PackageID
						}
					]
				}
			)
			break;











		//////////////////////////////////////////////
		default:
			break;
	}
};

export default dataService;